import React, { useState, useEffect } from 'react';
import api, { getEventos, createEvento, createLote, updateLote, deleteLote, getInscricoes, getEvento, updateEvento, getCupons, createCupom, updateCupom, deleteCupom, confirmarInscricaoManual, reenviarEmailConfirmacao, buscarTicket, confirmarPresenca, createInscricaoInterna, listarUsuariosAdmin, criarUsuarioAdmin, atualizarUsuarioAdmin, excluirUsuarioAdmin, alterarSenhaAdmin } from '../api';
import { Scanner } from '@yudiel/react-qr-scanner';
import toastr from 'toastr';
import { PDFDownloadLink } from '@react-pdf/renderer';
import InscritosPDF from '../components/InscritosPDF';
import { getInscricaoCancelamentoInfo } from '../utils/inscricoesUtils';
import ReactPaginate from 'react-paginate';

const formatLocalDatetime = (dateString) => {
  if (!dateString) return '';
  const d = new Date(dateString);
  if (isNaN(d.getTime())) return '';
  const pad = (n) => n.toString().padStart(2, '0');
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
};

export default function AdminDashboard() {
  const [confirmModal, setConfirmModal] = useState({
    show: false,
    title: '',
    message: '',
    onConfirm: null
  });

  const showConfirm = (title, message, onConfirm) => {
    setConfirmModal({
      show: true,
      title,
      message,
      onConfirm: () => {
        onConfirm();
        setConfirmModal(prev => ({ ...prev, show: false }));
      }
    });
  };

  const [eventos, setEventos] = useState([]);
  const [selectedEvento, setSelectedEvento] = useState(null);
  const [isCreating, setIsCreating] = useState(false);
  const [inscricoes, setInscricoes] = useState([]);
  const [lotes, setLotes] = useState([]);

  const [novoEvento, setNovoEvento] = useState({ titulo: '', slug: '', descricao: '', imagem_url: '', data_evento: '', data_validade_evento: '', preco: '', quantidade: '', data_validade: '', destaque: 0, local: '' });
  const [adminEventSearch, setAdminEventSearch] = useState('');
  const [camposPersonalizados, setCamposPersonalizados] = useState([]);
  const [novoLote, setNovoLote] = useState({ nome: '', preco: 0, quantidade: 0, data_validade: '', data_inicio: '', visivel_publico: 1, principal: 1, permite_duplicidade: 0 });
  const [editEvento, setEditEvento] = useState(null);
  const [editCamposPersonalizados, setEditCamposPersonalizados] = useState([]);
  const [activeTab, setActiveTab] = useState('inscricoes');
  const [checkinMethod, setCheckinMethod] = useState('camera');
  const [inscricaoSearch, setInscricaoSearch] = useState('');
  const [inscricaoStatusFilter, setInscricaoStatusFilter] = useState('todos');
  const [inscricaoLoteFilter, setInscricaoLoteFilter] = useState('todos');
  const [inscricoesPage, setInscricoesPage] = useState(1);
  const [inscricoesPerPage] = useState(6);
  const [editingInscricao, setEditingInscricao] = useState(null);
  const [actionMenuOpenId, setActionMenuOpenId] = useState(null);
  const [editInscricaoData, setEditInscricaoData] = useState({ nome: '', email: '', telefone: '', cpf: '', respostas: {} });
  const [editingLote, setEditingLote] = useState(null);
  const [editingCupom, setEditingCupom] = useState(null);
  const [formDataInterna, setFormDataInterna] = useState({ nome: '', email: '', telefone: '', cpf: '', lote_id: '' });
  const [respostasInterna, setRespostasInterna] = useState({});
  const [submittingInterna, setSubmittingInterna] = useState(false);
  const [usuariosAdmin, setUsuariosAdmin] = useState([]);
  const [usuarioForm, setUsuarioForm] = useState({ usuario: '', nome: '', senha: '', permissoes: [] });
  const [usuarioEditando, setUsuarioEditando] = useState(null);
  const [isManagingUsuarios, setIsManagingUsuarios] = useState(false);
  const [showUsuarioModal, setShowUsuarioModal] = useState(false);
  const [showSenhaModal, setShowSenhaModal] = useState(false);
  const [senhaForm, setSenhaForm] = useState({ usuarioId: null, nome: '', novaSenha: '' });

  // Cupons
  const [isManagingCupons, setIsManagingCupons] = useState(false);
  const [cupons, setCupons] = useState([]);
  const [novoCupom, setNovoCupom] = useState({ codigo: '', tipo: 'porcentagem', valor: '', quantidade_limite: '', data_validade: '', evento_id: '' });
  const [showLoteModal, setShowLoteModal] = useState(false);
  const [showCupomModal, setShowCupomModal] = useState(false);

  // QR Credenciamento
  const [scannerActive, setScannerActive] = useState(false);

  const normalizePermissaoValue = (perm) => String(perm || '').trim().toUpperCase();

  const normalizePermissoes = (permissoes) => {
    if (Array.isArray(permissoes)) {
      return permissoes
        .map((item) => normalizePermissaoValue(item))
        .filter(Boolean);
    }

    if (typeof permissoes === 'string') {
      const trimmed = permissoes.trim();
      if (!trimmed) return [];
      if (trimmed.startsWith('[')) {
        try {
          const parsed = JSON.parse(trimmed);
          if (Array.isArray(parsed)) {
            return normalizePermissoes(parsed);
          }
        } catch {
          // fallback below
        }
      }
      return trimmed.split(',').map((item) => normalizePermissaoValue(item)).filter(Boolean);
    }

    return [];
  };

  const getPermissoesAdmin = () => {
    if (typeof window === 'undefined') return [];
    try {
      const user = JSON.parse(localStorage.getItem('adminUser') || '{}');
      return normalizePermissoes(user.PERMISSOES);
    } catch {
      return [];
    }
  };

  const getAdminUserAtual = () => {
    if (typeof window === 'undefined') return null;
    try {
      return JSON.parse(localStorage.getItem('adminUser') || 'null');
    } catch {
      return null;
    }
  };

  const permissoesAdmin = getPermissoesAdmin();
  const adminUserAtual = getAdminUserAtual();
  const hasPermissao = (perm) => {
    const normalizedPerm = normalizePermissaoValue(perm);
    return permissoesAdmin.length === 0 || permissoesAdmin.includes(normalizedPerm);
  };

  // CPF Credenciamento
  const [cpfCheckin, setCpfCheckin] = useState('');
  const [loadingCpf, setLoadingCpf] = useState(false);

  // Fluxo de Credenciamento com Aprovação Manual
  const [pendingTicket, setPendingTicket] = useState(null);
  const [ticketOptions, setTicketOptions] = useState([]); // quando a pessoa tem mais de um lote no mesmo evento
  const [scanError, setScanError] = useState(null);
  const [loadingCheckin, setLoadingCheckin] = useState(false);
  const [checkinSuccess, setCheckinSuccess] = useState(null);

  useEffect(() => {
    loadEventos();
    loadCupons();
    loadUsuariosAdmin();
  }, []);

  useEffect(() => {
    setInscricoesPage(1);
  }, [inscricaoSearch, inscricaoStatusFilter, inscricaoLoteFilter]);

  const loadEventos = () => {
    getEventos().then(setEventos).catch(console.error);
  };

  const loadCupons = () => {
    getCupons().then(setCupons).catch(console.error);
  };

  const loadUsuariosAdmin = async () => {
    try {
      const res = await listarUsuariosAdmin();
      const usuarios = (res?.DATA || []).map((usuario) => ({
        ...usuario,
        PERMISSOES: normalizePermissoes(usuario.PERMISSOES)
      }));
      setUsuariosAdmin(usuarios);
    } catch (err) {
      console.error(err);
    }
  };

  const handleSaveCupom = async (e) => {
    e.preventDefault();
    if (!selectedEvento) return;
    try {
      if (editingCupom) {
        const res = await updateCupom(editingCupom.id, editingCupom);
        if (res.success) {
          toastr.success('Cupom atualizado com sucesso!');
          setEditingCupom(null);
          setShowCupomModal(false);
          loadCupons();
        } else {
          toastr.error(res.error || 'Erro ao atualizar cupom.');
        }
      } else {
        const res = await createCupom({
          ...novoCupom,
          evento_id: selectedEvento.id
        });
        if (res.success) {
          toastr.success('Cupom criado com sucesso!');
          setNovoCupom({ codigo: '', tipo: 'porcentagem', valor: '', quantidade_limite: '', data_validade: '', evento_id: '' });
          setShowCupomModal(false);
          loadCupons();
        } else {
          toastr.error(res.error || 'Erro ao criar cupom.');
        }
      }
    } catch (err) {
      toastr.error(editingCupom ? 'Erro ao atualizar cupom.' : 'Erro ao criar cupom.');
    }
  };

  const abrirModalUsuario = (usuario = null) => {
    if (usuario) {
      setUsuarioEditando(usuario);
      setUsuarioForm({
        usuario: usuario.USUARIO || usuario.usuario || '',
        nome: usuario.NOME || usuario.nome || '',
        senha: '',
        permissoes: normalizePermissoes(usuario.PERMISSOES)
      });
    } else {
      setUsuarioEditando(null);
      setUsuarioForm({ usuario: '', nome: '', senha: '', permissoes: [] });
    }
    setShowUsuarioModal(true);
  };

  const fecharModalUsuario = () => {
    setShowUsuarioModal(false);
    setUsuarioEditando(null);
    setUsuarioForm({ usuario: '', nome: '', senha: '', permissoes: [] });
  };

  const togglePermissao = (perm) => {
    const normalizedPerm = normalizePermissaoValue(perm);
    setUsuarioForm(prev => ({
      ...prev,
      permissoes: prev.permissoes.includes(normalizedPerm)
        ? prev.permissoes.filter(item => item !== normalizedPerm)
        : [...prev.permissoes, normalizedPerm]
    }));
  };

  const handleSalvarUsuario = async (e) => {
    e.preventDefault();
    try {
      if (usuarioEditando) {
        const res = await atualizarUsuarioAdmin(usuarioEditando.ID || usuarioEditando.id, {
          usuario: usuarioForm.usuario,
          nome: usuarioForm.nome,
          permissoes: usuarioForm.permissoes
        });
        if (res?.SUCCESS) {
          toastr.success('Usuário atualizado com sucesso!');
          fecharModalUsuario();
          loadUsuariosAdmin();
        }
      } else {
        const res = await criarUsuarioAdmin({
          usuario: usuarioForm.usuario,
          nome: usuarioForm.nome,
          senha: usuarioForm.senha,
          permissoes: usuarioForm.permissoes
        });
        if (res?.SUCCESS) {
          toastr.success('Usuário criado com sucesso!');
          fecharModalUsuario();
          loadUsuariosAdmin();
        }
      }
    } catch (err) {
      toastr.error('Erro ao salvar usuário.');
    }
  };

  const abrirModalSenha = (usuario) => {
    setSenhaForm({
      usuarioId: usuario?.ID || usuario?.id || null,
      nome: usuario?.NOME || usuario?.nome || usuario?.USUARIO || usuario?.usuario || '',
      novaSenha: ''
    });
    setShowSenhaModal(true);
  };

  const fecharModalSenha = () => {
    setShowSenhaModal(false);
    setSenhaForm({ usuarioId: null, nome: '', novaSenha: '' });
  };

  const handleSalvarSenha = async (e) => {
    e.preventDefault();
    if (!senhaForm.usuarioId || !senhaForm.novaSenha) return;

    try {
      const res = await alterarSenhaAdmin(senhaForm.usuarioId, senhaForm.novaSenha);
      if (res?.SUCCESS || res?.success) {
        toastr.success('Senha alterada com sucesso!');
        fecharModalSenha();
      } else {
        toastr.error(res?.ERROR || res?.error || 'Erro ao alterar senha.');
      }
    } catch (err) {
      toastr.error('Erro ao alterar senha.');
    }
  };

  const handleExcluirUsuario = async (usuario) => {
    showConfirm(
      'Excluir usuário',
      `Deseja remover ${usuario.NOME || usuario.nome}?`,
      async () => {
        try {
          const res = await excluirUsuarioAdmin(usuario.ID || usuario.id);
          if (res?.SUCCESS) {
            toastr.success('Usuário excluído com sucesso!');
            loadUsuariosAdmin();
          }
        } catch (err) {
          toastr.error('Erro ao excluir usuário.');
        }
      }
    );
  };

  const handleEditarUsuario = (usuario) => {
    abrirModalUsuario(usuario);
  };

  const handleCreateInscricaoInterna = async (e) => {
    e.preventDefault();
    if (!selectedEvento) return;
    if (!formDataInterna.lote_id) {
      toastr.warning('Selecione um lote.');
      return;
    }
    setSubmittingInterna(true);
    try {
      const res = await createInscricaoInterna({
        evento_id: selectedEvento.id,
        ...formDataInterna,
        respostas: respostasInterna
      });
      if (res.success) {
        toastr.success('Inscrição interna realizada com sucesso!');
        setFormDataInterna({ nome: '', email: '', telefone: '', cpf: '', lote_id: '' });
        setRespostasInterna({});
        loadInscricoes(selectedEvento); // Atualiza os inscritos
      } else {
        toastr.error(res.error || 'Erro ao realizar inscrição interna.');
      }
    } catch (err) {
      console.error(err);
      toastr.error(err.response?.data?.error || 'Erro de conexão ao processar inscrição.');
    } finally {
      setSubmittingInterna(false);
    }
  };

  const handleDeleteCupom = async (id) => {
    showConfirm(
      'Excluir Cupom',
      'Tem certeza de que deseja excluir este cupom permanentemente?',
      async () => {
        try {
          const res = await deleteCupom(id);
          if (res.success) {
            loadCupons();
            toastr.success('Cupom excluído com sucesso!');
          } else {
            toastr.error(res.error || 'Erro ao excluir cupom.');
          }
        } catch (err) {
          toastr.error('Erro ao excluir cupom.');
        }
      }
    );
  };

  const handleConfirmInscricao = async (id) => {
    showConfirm(
      'Confirmar Inscrição',
      'Confirmar pagamento manualmente? O participante receberá o e-mail com QR Code.',
      async () => {
        try {
          const res = await confirmarInscricaoManual(id);
          if (res.success) {
            toastr.success('Inscrição confirmada com sucesso!');
            loadInscricoes(selectedEvento);
          } else {
            toastr.error(res.error || 'Erro ao confirmar.');
          }
        } catch (err) {
          toastr.error('Erro ao conectar.');
        }
      }
    );
  };

  const handleResendEmail = async (id) => {
    try {
      const res = await reenviarEmailConfirmacao(id);
      if (res.success) {
        toastr.success('E-mail de confirmação reenviado!');
      } else {
        toastr.error(res.error || 'Erro ao reenviar.');
      }
    } catch (err) {
      toastr.error('Erro ao conectar.');
    }
  };

  const openEditInscricao = (inscricao) => {
    let respostas = {};
    try {
      respostas = typeof inscricao?.respostas === 'string' ? JSON.parse(inscricao.respostas) : (inscricao?.respostas || {});
    } catch (e) {
      respostas = {};
    }

    setEditingInscricao(inscricao);
    setEditInscricaoData({
      nome: inscricao?.nome || '',
      email: inscricao?.email || '',
      telefone: inscricao?.telefone || '',
      cpf: inscricao?.cpf || '',
      respostas
    });
  };

  const handleSaveInscricaoEdit = async () => {
    if (!editingInscricao) return;
    try {
      const payload = {
        ...editInscricaoData,
        respostas: editInscricaoData.respostas || {}
      };
      const res = await api.put(`/eventos/inscricoes/${editingInscricao.id}`, payload);
      if (res.data?.success) {
        toastr.success('Inscrição atualizada com sucesso!');
        setEditingInscricao(null);
        loadInscricoes(selectedEvento);
      } else {
        toastr.error(res.data?.error || 'Erro ao atualizar inscrição.');
      }
    } catch (err) {
      toastr.error(err.response?.data?.error || 'Erro ao atualizar inscrição.');
    }
  };

  const handleCancelInscricao = async (inscricao) => {
    const info = getInscricaoCancelamentoInfo(inscricao, selectedEvento);
    if (!info.canCancel) {
      toastr.warning(info.reason);
      return;
    }

    showConfirm(
      'Cancelar inscrição',
      info.refundAllowed
        ? `Deseja cancelar esta inscrição e emitir reembolso de ${Number(inscricao.valor_pago || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}?`
        : 'Deseja cancelar esta inscrição? O reembolso não é permitido para este caso.',
      async () => {
        try {
          const res = await api.post(`/eventos/inscricoes/${inscricao.id}/cancelar`, {
            reembolsar: info.refundAllowed
          });
          if (res.data?.success) {
            toastr.success(info.refundAllowed ? 'Inscrição cancelada e reembolso processado.' : 'Inscrição cancelada.');
            loadInscricoes(selectedEvento);
          } else {
            toastr.error(res.data?.error || 'Erro ao cancelar inscrição.');
          }
        } catch (err) {
          toastr.error(err.response?.data?.error || 'Erro ao cancelar inscrição.');
        }
      }
    );
  };

  // QR Code camera actions
  useEffect(() => {
    setPendingTicket(null);
    setCheckinSuccess(null);
    setScanError(null);
    setScannerActive(false);
  }, [activeTab, checkinMethod]);

  const startScanner = () => {
    setPendingTicket(null);
    setScanError(null);
    setCheckinSuccess(null);
    setScannerActive(true);
  };

  const stopScanner = () => {
    setScannerActive(false);
  };

  const handleScan = async (decodedText) => {
    if (!decodedText || !decodedText.length) return;
    try {
      setScannerActive(false);
      const res = await buscarTicket(decodedText[0].rawValue, null, null);
      if (res.success) {
        setTicketOptions(res.inscricoes || [res.inscricao]);
        setPendingTicket(res.inscricao);
        setScanError(null);
      } else {
        setScanError(res.error || 'Erro ao buscar inscrição.');
      }
    } catch (e) {
      setScanError(e.response?.data?.error || 'Erro de conexão ou QR Code inválido.');
    }
  };

  const handleCpfCheckin = async (e) => {
    e.preventDefault();
    if (!cpfCheckin || !selectedEvento) return;
    setLoadingCpf(true);
    setScanError(null);
    setPendingTicket(null);
    setTicketOptions([]);
    setCheckinSuccess(null);
    try {
      const res = await buscarTicket(null, cpfCheckin, selectedEvento.id);
      if (res.success) {
        const opcoes = res.inscricoes || [res.inscricao];
        setTicketOptions(opcoes);
        // Se só encontrou uma inscrição, já abre direto os detalhes
        if (opcoes.length === 1) setPendingTicket(opcoes[0]);
        setCpfCheckin('');
      } else {
        setScanError(res.error || 'Inscrição com este CPF não foi localizada.');
      }
    } catch (err) {
      setScanError(err.response?.data?.error || 'Inscrição com este CPF não foi localizada.');
    } finally {
      setLoadingCpf(false);
    }
  };

  const handleApproveCheckin = async () => {
    if (!pendingTicket) return;
    setLoadingCheckin(true);
    try {
      const res = await confirmarPresenca(pendingTicket.id);
      if (res.success) {
        setCheckinSuccess(res.message);
        setPendingTicket(null);
        setTicketOptions([]);
        if (selectedEvento) {
          loadInscricoes(selectedEvento);
        }
      } else {
        setScanError(res.error || 'Erro ao confirmar credenciamento.');
      }
    } catch (err) {
      setScanError(err.response?.data?.error || 'Erro ao confirmar presença no servidor.');
    } finally {
      setLoadingCheckin(false);
    }
  };

  const handleCancelCheckin = () => {
    setPendingTicket(null);
    setTicketOptions([]);
    setScanError(null);
    setCheckinSuccess(null);
  };

  const handleCreateEvento = async (e) => {
    e.preventDefault();
    try {
      await createEvento({ ...novoEvento, campos_personalizados: camposPersonalizados });
      setNovoEvento({ titulo: '', slug: '', descricao: '', imagem_url: '', data_evento: '', data_validade_evento: '', preco: '', quantidade: '', data_validade: '', destaque: 0, local: '' });
      setCamposPersonalizados([]);
      setIsCreating(false);
      loadEventos();
    } catch (err) {
      toastr.error('Erro ao criar evento.');
    }
  };

  const handleSaveLote = async (e) => {
    e.preventDefault();
    if (!selectedEvento) return;
    try {
      if (editingLote) {
        await updateLote(editingLote.id, editingLote);
        toastr.success('Lote atualizado com sucesso!');
        setEditingLote(null);
      } else {
        await createLote(selectedEvento.id, novoLote);
        toastr.success('Lote criado com sucesso!');
        setNovoLote({ nome: '', preco: 0, quantidade: 0, data_validade: '', data_inicio: '', visivel_publico: 1, principal: 1, permite_duplicidade: 0 });
      }
      setShowLoteModal(false);
      // Atualiza a lista de lotes
      loadInscricoes(selectedEvento);
    } catch (err) {
      toastr.error(editingLote ? 'Erro ao atualizar lote.' : 'Erro ao criar lote.');
    }
  };

  const handleDeleteLote = async (id) => {
    showConfirm(
      'Excluir Lote',
      'Tem certeza de que deseja excluir este lote? Esta ação não pode ser desfeita.',
      async () => {
        try {
          const res = await deleteLote(id);
          if (res.success) {
            toastr.success('Lote excluído com sucesso!');
            loadInscricoes(selectedEvento);
          } else {
            toastr.error(res.error || 'Erro ao excluir lote.');
          }
        } catch (err) {
          toastr.error('Erro ao excluir lote.');
        }
      }
    );
  };

  const handleUpdateEvento = async (e) => {
    e.preventDefault();
    try {
      await updateEvento(selectedEvento.id, { ...editEvento, campos_personalizados: editCamposPersonalizados });
      loadEventos();
    } catch (err) {
      toastr.error('Erro ao atualizar evento.');
    }
  };

  const loadInscricoes = async (evento, tabToSet = null) => {
    setSelectedEvento(evento);
    setEditEvento({ ...evento });
    setInscricaoSearch('');
    setInscricaoStatusFilter('todos');
    setInscricaoLoteFilter('todos');
    setInscricoesPage(1);
    const defaultTab = hasPermissao('inscricoes')
      ? 'inscricoes'
      : hasPermissao('lotes')
        ? 'lotes'
        : hasPermissao('cupons')
          ? 'cupons'
          : hasPermissao('credenciamento')
            ? 'credenciamento'
            : hasPermissao('editar')
              ? 'editar'
              : hasPermissao('inscricao_interna')
                ? 'inscricao_interna'
                : 'acesso_negado';
    if (tabToSet) {
      setActiveTab(tabToSet);
    } else if (!selectedEvento) {
      setActiveTab(defaultTab);
    } else {
      setActiveTab(defaultTab);
    }
    try {
      const campos = typeof evento.campos_personalizados === 'string' ? JSON.parse(evento.campos_personalizados) : (evento.campos_personalizados || []);
      setEditCamposPersonalizados(campos);
    } catch (e) { setEditCamposPersonalizados([]); }
    setIsCreating(false);
    try {
      const dataInsc = await getInscricoes(evento.id);
      setInscricoes(dataInsc);

      const fullEvento = await getEvento(evento.slug);
      setLotes(fullEvento?.lotes || []);
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <div className="container-fluid py-3 py-md-4 min-vh-100 bg-light">
      <div className="row g-3 g-md-4">

        {/* Sidebar / Menu Lateral Responsivo */}
        <div className="col-12 col-lg-2">
          <div className="card shadow-sm border-0 rounded-3 p-3 bg-white">
            <div className="d-flex justify-content-between align-items-center mb-3 pb-2 border-bottom">
              <h2 className="fs-6 fw-bold text-dark mb-0">Painel IAC</h2>
              <button
                className="btn btn-outline-danger btn-sm px-2 py-1 rounded-pill fw-semibold"
                style={{ fontSize: '0.78rem' }}
                onClick={() => { localStorage.removeItem('adminAuth'); window.location.href = '/'; }}
              >
                Sair
              </button>
            </div>

            <div className="d-flex flex-column gap-1">
              <button
                onClick={() => { setSelectedEvento(null); setIsCreating(false); setIsManagingCupons(false); setIsManagingUsuarios(false); }}
                className={`btn py-2 px-3 rounded-3 text-start fw-semibold shadow-none border-0 transition-all ${!selectedEvento && !isCreating && !isManagingCupons && !isManagingUsuarios ? 'btn-primary text-white shadow-sm' : 'btn-light text-dark bg-transparent'}`}
                style={{ fontSize: '0.85rem' }}
              >
                🏠 Visão Geral
              </button>
              {hasPermissao('usuarios') && (
                <button
                  onClick={() => { setSelectedEvento(null); setIsCreating(false); setIsManagingCupons(false); setIsManagingUsuarios(true); }}
                  className={`btn py-2 px-3 rounded-3 text-start fw-semibold shadow-none border-0 transition-all ${isManagingUsuarios ? 'btn-primary text-white shadow-sm' : 'btn-light text-dark bg-transparent'}`}
                  style={{ fontSize: '0.85rem' }}
                >
                  👤 Usuários
                </button>
              )}
            </div>
          </div>
        </div>

        {/* Conteudo Principal */}
        <div className="col-12 col-lg-10">

          {/* Visão Geral (Grid de Eventos) */}
          {!selectedEvento && !isCreating && !isManagingCupons && !isManagingUsuarios && (() => {
            const filteredEventos = eventos.filter(ev => {
              if (!adminEventSearch) return true;
              const lower = adminEventSearch.toLowerCase();
              const tituloMatch = ev.titulo && ev.titulo.toLowerCase().includes(lower);
              const descMatch = ev.descricao && ev.descricao.toLowerCase().includes(lower);
              const dateStr = ev.data_evento ? new Date(ev.data_evento).toLocaleDateString('pt-BR').toLowerCase() : '';
              const dateMatch = dateStr.includes(lower);
              return tituloMatch || descMatch || dateMatch;
            });

            return (
              <div>
                <div className="d-flex flex-column flex-md-row justify-content-between align-items-md-center gap-3 mb-4">
                  <div>
                    <h2 className="fs-4 fw-bold text-dark mb-0">Eventos</h2>
                    <p className="text-secondary small mb-0">
                      {filteredEventos.length} evento{filteredEventos.length !== 1 ? 's' : ''} encontrado{filteredEventos.length !== 1 ? 's' : ''}
                    </p>
                  </div>
                  <div className="d-flex align-items-center gap-3 flex-wrap">
                    {/* Filtro de Busca */}
                    <div style={{ minWidth: '260px' }}>
                      <div className="d-flex align-items-center gap-2 rounded-3 bg-light px-3 py-2 border">
                        <span className="text-secondary">🔍</span>
                        <input
                          type="text"
                          className="border-0 bg-transparent w-100 shadow-none small"
                          style={{ outline: 'none', fontSize: '0.875rem', color: '#374151' }}
                          placeholder="Buscar por descrição ou data..."
                          value={adminEventSearch}
                          onChange={e => setAdminEventSearch(e.target.value)}
                        />
                      </div>
                    </div>
                    <button className="btn btn-primary px-4 py-2 fw-semibold rounded-3 shadow-sm" onClick={() => setIsCreating(true)}>+ Novo Evento</button>
                  </div>
                </div>

                <div className="row g-3">
                  {filteredEventos.map(ev => {
                    const dataReferencia = ev.data_validade_evento || ev.data_evento;
                    const isEncerrado = dataReferencia && new Date(dataReferencia) < new Date();
                    const semLotePrincipal = ev.preco === null || ev.preco === undefined || ev.preco === "";
                    const statusBadge = isEncerrado
                      ? { texto: '🔒 Encerrado', classe: 'bg-danger text-white' }
                      : semLotePrincipal
                        ? { texto: '⏳ Em Breve', classe: 'bg-warning text-dark' }
                        : { texto: '🌐 Ativo', classe: 'bg-success text-white' };
                    return (
                      <div key={ev.id} className="col-12 col-md-6 col-xxl-4" style={{ cursor: 'pointer' }} onClick={() => loadInscricoes(ev)}>
                        <div className="card border-0 h-100 shadow-sm hover-shadow transition-all rounded-4 overflow-hidden position-relative">
                          <div style={{ position: 'absolute', top: '12px', right: '12px', zIndex: 10 }}>
                            <span className={`badge px-2.5 py-1.5 rounded-3 fw-bold shadow-sm ${statusBadge.classe}`} style={{ fontSize: '0.72rem' }}>
                              {statusBadge.texto}
                            </span>
                          </div>
                          {ev.destaque === 1 && (
                            <div style={{ position: 'absolute', top: '12px', left: '12px', zIndex: 10 }}>
                              <span className="badge bg-warning text-dark px-2.5 py-1.5 rounded-3 fw-bold shadow-sm" style={{ fontSize: '0.72rem' }}>
                                ✨ Destaque
                              </span>
                            </div>
                          )}
                          <div style={{ height: '180px', overflow: 'hidden' }}>
                            <img src={ev.imagem_url || 'https://images.unsplash.com/photo-1540575467063-178a50c2df87?q=80&w=2070'} alt={ev.titulo} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                          </div>
                          <div className="card-body d-flex flex-column justify-content-between">
                            <h3 className="card-title h5 fw-bold text-dark mb-2">{ev.titulo}</h3>
                            <div className="text-secondary small mt-auto">
                              Data: {ev.data_evento ? new Date(ev.data_evento).toLocaleString('pt-BR') : 'Sem data'}
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                  {filteredEventos.length === 0 && (
                    <div className="col-12 text-center py-5">
                      <div className="text-secondary">
                        <div style={{ fontSize: '3rem' }}>🗓️</div>
                        <p className="fs-5 mt-2 mb-3">Nenhum evento encontrado.</p>
                        {!adminEventSearch && (
                          <button className="btn btn-primary px-4 py-2 fw-semibold rounded-3" onClick={() => setIsCreating(true)}>+ Criar Primeiro Evento</button>
                        )}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            );
          })()}

          {/* Gerenciamento de Usuários */}
          {!selectedEvento && isManagingUsuarios && (
            hasPermissao('usuarios') ? (
              <div className="card border-0 shadow-sm p-4 p-md-5 rounded-4 bg-white">
                <div className="d-flex justify-content-between align-items-center mb-4 flex-wrap gap-3">
                  <div>
                    <h3 className="fw-bold text-dark mb-1">Gerenciar usuários administrativos</h3>
                    <p className="text-secondary small mb-0">Cadastre usuários e defina quais menus cada um pode acessar.</p>
                  </div>
                  <div className="d-flex gap-2">
                    <button type="button" className="btn btn-primary px-3 py-2 rounded-pill fw-semibold small" onClick={() => abrirModalUsuario()}>
                      + Cadastrar usuário
                    </button>
                    <button type="button" className="btn btn-outline-secondary px-3 py-2 rounded-pill fw-semibold small" onClick={() => { setIsManagingUsuarios(false); fecharModalUsuario(); }}>
                      ← Voltar
                    </button>
                  </div>
                </div>

                <div className="table-responsive">
                  <table className="table align-middle mb-0">
                    <thead>
                      <tr className="text-secondary small">
                        <th>Usuário</th>
                        <th>Nome</th>
                        <th>Ações</th>
                      </tr>
                    </thead>
                    <tbody>
                      {usuariosAdmin.map(usuario => (
                        <tr key={usuario.ID || usuario.id}>
                          <td className="fw-semibold text-dark">{usuario.USUARIO || usuario.usuario}</td>
                          <td>{usuario.NOME || usuario.nome}</td>
                          <td>
                            <div className="d-flex gap-2 flex-wrap">
                              <button className="btn btn-sm btn-outline-primary" onClick={() => handleEditarUsuario(usuario)}>Editar</button>
                              <button className="btn btn-sm btn-outline-secondary" onClick={() => abrirModalSenha(usuario)}>
                                {(adminUserAtual?.ID || adminUserAtual?.id) && Number(adminUserAtual.ID || adminUserAtual.id) === Number(usuario.ID || usuario.id)
                                  ? 'Minha senha'
                                  : 'Trocar senha'}
                              </button>
                              <button className="btn btn-sm btn-outline-danger" onClick={() => handleExcluirUsuario(usuario)}>Excluir</button>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>

                {showSenhaModal && (
                  <div className="modal d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.45)' }}>
                    <div className="modal-dialog modal-dialog-centered">
                      <div className="modal-content border-0 rounded-4">
                        <div className="modal-header border-0 pb-0">
                          <div>
                            <h5 className="modal-title fw-bold text-dark">Trocar senha</h5>
                            <p className="text-secondary small mb-0">Defina uma nova senha para {senhaForm.nome || 'este usuário'}.</p>
                          </div>
                          <button type="button" className="btn-close" onClick={fecharModalSenha}></button>
                        </div>
                        <form onSubmit={handleSalvarSenha}>
                          <div className="modal-body">
                            <label className="form-label text-secondary small fw-semibold">Nova senha</label>
                            <input type="password" className="form-control" value={senhaForm.novaSenha} onChange={e => setSenhaForm({ ...senhaForm, novaSenha: e.target.value })} required />
                          </div>
                          <div className="modal-footer border-0 pt-0">
                            <button type="button" className="btn btn-outline-secondary" onClick={fecharModalSenha}>Cancelar</button>
                            <button type="submit" className="btn btn-primary">Salvar senha</button>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                )}

                {showUsuarioModal && (
                  <div className="modal d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.45)' }}>
                    <div className="modal-dialog modal-lg modal-dialog-centered">
                      <div className="modal-content border-0 rounded-4">
                        <div className="modal-header border-0 pb-0">
                          <div>
                            <h5 className="modal-title fw-bold text-dark">{usuarioEditando ? 'Editar usuário' : 'Cadastrar usuário'}</h5>
                            <p className="text-secondary small mb-0">Defina os dados e permissões deste acesso administrativo.</p>
                          </div>
                          <button type="button" className="btn-close" onClick={fecharModalUsuario}></button>
                        </div>
                        <form onSubmit={handleSalvarUsuario}>
                          <div className="modal-body">
                            <div className="row g-3">
                              <div className="col-12 col-md-6">
                                <label className="form-label text-secondary small fw-semibold">Usuário</label>
                                <input className="form-control" value={usuarioForm.usuario} onChange={e => setUsuarioForm({ ...usuarioForm, usuario: e.target.value })} required />
                              </div>
                              <div className="col-12 col-md-6">
                                <label className="form-label text-secondary small fw-semibold">Nome</label>
                                <input className="form-control" value={usuarioForm.nome} onChange={e => setUsuarioForm({ ...usuarioForm, nome: e.target.value })} required />
                              </div>
                              {!usuarioEditando ? (
                                <div className="col-12">
                                  <label className="form-label text-secondary small fw-semibold">Senha</label>
                                  <input type="password" className="form-control" value={usuarioForm.senha} onChange={e => setUsuarioForm({ ...usuarioForm, senha: e.target.value })} required />
                                  <small className="text-secondary">Obrigatório para criar o usuário.</small>
                                </div>
                              ) : (
                                <div className="col-12">
                                  <div className="border rounded-3 p-3 bg-light">
                                    <p className="fw-semibold mb-1 text-dark">Senha</p>
                                    <p className="text-secondary small mb-0">Para alterar a senha deste usuário, use o botão “Trocar senha” na lista.</p>
                                  </div>
                                </div>
                              )}
                            </div>

                            <div className="mt-4 border-top pt-3">
                              <h6 className="fw-bold text-dark mb-2">Permissões por menu</h6>
                              <p className="text-secondary small mb-3">Selecione quais menus este acesso poderá visualizar.</p>
                              <div className="row g-2">
                                {['inscricoes', 'lotes', 'cupons', 'credenciamento', 'editar', 'inscricao_interna', 'usuarios'].map(perm => (
                                  <div key={perm} className="col-12 col-sm-6 col-md-4">
                                    <label className="d-flex align-items-center gap-2 border rounded-3 p-2 bg-white">
                                      <input type="checkbox" checked={usuarioForm.permissoes.includes(normalizePermissaoValue(perm))} onChange={() => togglePermissao(perm)} />
                                      <span className="small text-secondary text-capitalize">{normalizePermissaoValue(perm).replace('_', ' ')}</span>
                                    </label>
                                  </div>
                                ))}
                              </div>
                            </div>
                          </div>
                          <div className="modal-footer border-0 pt-0">
                            <button type="button" className="btn btn-outline-secondary" onClick={fecharModalUsuario}>Cancelar</button>
                            <button type="submit" className="btn btn-primary">{usuarioEditando ? 'Salvar alterações' : 'Criar usuário'}</button>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            ) : (
              <div className="card border-0 shadow-sm p-4 p-md-5 rounded-4 bg-white">
                <div className="alert alert-warning mb-0">Você não possui permissão para acessar este módulo.</div>
              </div>
            )
          )}

          {/* Formulário Novo Evento */}
          {isCreating && (
            <div className="card border-0 shadow-sm p-4 p-md-5 rounded-4 bg-white">
              <div className="d-flex justify-content-between align-items-center mb-4">
                <div>
                  <h3 className="fw-bold text-dark mb-1">Criar Novo Evento</h3>
                  <p className="text-secondary small mb-0">Preencha os dados abaixo para criar um novo evento.</p>
                </div>
                <button type="button" className="btn btn-outline-secondary px-3 py-2 rounded-pill fw-semibold small" onClick={() => setIsCreating(false)}>← Voltar</button>
              </div>
              <form onSubmit={handleCreateEvento}>
                <div className="form-group">
                  <label className="form-label">Título</label>
                  <input className="form-control" value={novoEvento.titulo} onChange={e => setNovoEvento({ ...novoEvento, titulo: e.target.value })} required />
                </div>
                <div className="form-group">
                  <label className="form-label">URL Slug (ex: meu-evento)</label>
                  <input className="form-control" value={novoEvento.slug} onChange={e => setNovoEvento({ ...novoEvento, slug: e.target.value })} required />
                </div>
                <div className="form-group">
                  <label className="form-label">Local do Evento</label>
                  <input className="form-control" value={novoEvento.local} onChange={e => setNovoEvento({ ...novoEvento, local: e.target.value })} placeholder="Ex: Salão Principal IAC, Rua de Exemplo, 123 - Buritama, SP" />
                </div>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem' }}>
                  <div className="form-group">
                    <label className="form-label">Data e Hora do Evento</label>
                    <input type="datetime-local" className="form-control" value={novoEvento.data_evento} onChange={e => setNovoEvento({ ...novoEvento, data_evento: e.target.value })} required />
                  </div>
                  <div className="form-group">
                    <label className="form-label">Data Limite de Inscrição Geral</label>
                    <input type="datetime-local" className="form-control" value={novoEvento.data_validade_evento} onChange={e => setNovoEvento({ ...novoEvento, data_validade_evento: e.target.value })} />
                  </div>
                </div>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem' }}>
                  <div className="form-group">
                    <label className="form-label">Valor da Inscrição (R$)</label>
                    <input type="number" step="0.01" className="form-control" value={novoEvento.preco} onChange={e => setNovoEvento({ ...novoEvento, preco: e.target.value })} placeholder="Ex: 50.00 ou 0 p/ Grátis" required />
                  </div>
                  <div className="form-group">
                    <label className="form-label">Vagas Disponíveis</label>
                    <input type="number" className="form-control" value={novoEvento.quantidade} onChange={e => setNovoEvento({ ...novoEvento, quantidade: e.target.value })} placeholder="Ex: 100" required />
                  </div>
                  <div className="form-group" style={{ gridColumn: '1 / -1' }}>
                    <label className="form-label">Data de Validade (Opcional)</label>
                    <input type="datetime-local" className="form-control" value={novoEvento.data_validade} onChange={e => setNovoEvento({ ...novoEvento, data_validade: e.target.value })} />
                  </div>
                  <div className="form-check form-switch mb-3" style={{ gridColumn: '1 / -1' }}>
                    <input className="form-check-input" type="checkbox" role="switch" id="switchDestaque" checked={novoEvento.destaque === 1} onChange={e => setNovoEvento({ ...novoEvento, destaque: e.target.checked ? 1 : 0 })} />
                    <label className="form-check-label fw-semibold" htmlFor="switchDestaque" style={{ cursor: 'pointer' }}>✨ Destacar este evento no carrossel da página principal</label>
                  </div>
                </div>
                <div className="form-group">
                  <label className="form-label">Imagem do Evento</label>
                  <input
                    type="file"
                    accept="image/*"
                    className="form-control"
                    onChange={e => {
                      const file = e.target.files[0];
                      if (file) {
                        const reader = new FileReader();
                        reader.onloadend = () => {
                          setNovoEvento({ ...novoEvento, imagem_url: reader.result });
                        };
                        reader.readAsDataURL(file);
                      }
                    }}
                  />
                  {novoEvento.imagem_url && (
                    <div className="mt-2" style={{ position: 'relative', display: 'inline-block' }}>
                      <img
                        src={novoEvento.imagem_url}
                        alt="Prévia"
                        style={{ maxHeight: '120px', borderRadius: '8px', border: '1px solid var(--border)' }}
                      />
                      <button
                        type="button"
                        className="btn btn-danger btn-sm"
                        style={{ position: 'absolute', top: '5px', right: '5px', borderRadius: '50%', padding: '0.25rem 0.5rem', fontSize: '0.75rem' }}
                        onClick={() => setNovoEvento({ ...novoEvento, imagem_url: '' })}
                      >
                        ✕
                      </button>
                    </div>
                  )}
                </div>
                <div className="form-group">
                  <label className="form-label">Descrição</label>
                  <textarea className="form-control" rows="4" value={novoEvento.descricao} onChange={e => setNovoEvento({ ...novoEvento, descricao: e.target.value })} required />
                </div>

                <div style={{ borderTop: '1px solid var(--border)', paddingTop: '1.5rem', marginTop: '1.5rem' }}>
                  <h4>Campos Personalizados (Formulário de Inscrição)</h4>
                  <p style={{ fontSize: '0.875rem', color: 'var(--text-secondary)', marginBottom: '1rem' }}>
                    Nome, Email e WhatsApp já são obrigatórios por padrão. Adicione campos extras se precisar (ex: RG, Restrição Alimentar).
                  </p>
                  {camposPersonalizados.map((campo, index) => (
                    <div key={index} style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 150px auto', gap: '1rem', marginBottom: '1rem', alignItems: 'end' }}>
                      <div>
                        <label className="form-label text-secondary small fw-semibold">Nome do Campo</label>
                        <input className="form-control" value={campo.nome} onChange={e => { const c = [...camposPersonalizados]; c[index].nome = e.target.value; setCamposPersonalizados(c); }} placeholder="Ex: RG, Tamanho Camiseta" required />
                      </div>
                      <div>
                        <label className="form-label text-secondary small fw-semibold">Placeholder (Dica p/ usuário)</label>
                        <input className="form-control" value={campo.placeholder || ''} onChange={e => { const c = [...camposPersonalizados]; c[index].placeholder = e.target.value; setCamposPersonalizados(c); }} placeholder="Ex: Digite seu RG" />
                      </div>
                      <div>
                        <label className="form-label text-secondary small fw-semibold">Tipo</label>
                        <select className="form-control form-select" value={campo.tipo || 'text'} onChange={e => { const c = [...camposPersonalizados]; c[index].tipo = e.target.value; setCamposPersonalizados(c); }}>
                          <option value="text">Texto Curto</option>
                          <option value="textarea">Texto Longo</option>
                          <option value="number">Número</option>
                          <option value="date">Data</option>
                        </select>
                      </div>
                      <button type="button" className="btn btn-outline-danger d-flex align-items-center justify-content-center" style={{ height: '42px', padding: '0 0.75rem' }} onClick={() => setCamposPersonalizados(camposPersonalizados.filter((_, i) => i !== index))}>
                        🗑️
                      </button>
                    </div>
                  ))}
                  <button type="button" className="btn btn-outline-secondary" style={{ borderStyle: 'dashed', width: '100%', marginBottom: '1.5rem' }} onClick={() => setCamposPersonalizados([...camposPersonalizados, { nome: '', tipo: 'text', placeholder: '' }])}>
                    + Adicionar Campo Extra
                  </button>
                </div>

                <button type="submit" className="btn btn-primary" style={{ width: '100%' }}>Salvar Evento Completo</button>
              </form>
            </div>
          )}

          {/* Menu do Evento Selecionado */}
          {selectedEvento && editEvento && (
            <div className="mb-4 pb-2 border-bottom print-hide d-flex justify-content-between align-items-center flex-wrap gap-3">
              <div className="d-flex flex-wrap gap-2">
                {hasPermissao('inscricoes') && (
                  <button
                    className={`btn px-4 py-2.5 rounded-3 fw-semibold small shadow-none border-0 transition-all ${activeTab === 'inscricoes' ? 'btn-primary text-white shadow-sm' : 'btn-light text-secondary bg-transparent'}`}
                    onClick={() => setActiveTab('inscricoes')}
                  >
                    👥 Inscritos
                  </button>
                )}
                {hasPermissao('lotes') && (
                  <button
                    className={`btn px-4 py-2.5 rounded-3 fw-semibold small shadow-none border-0 transition-all ${activeTab === 'lotes' ? 'btn-primary text-white shadow-sm' : 'btn-light text-secondary bg-transparent'}`}
                    onClick={() => setActiveTab('lotes')}
                  >
                    🎟️ Lotes e Vagas
                  </button>
                )}
                {hasPermissao('cupons') && (
                  <button
                    className={`btn px-4 py-2.5 rounded-3 fw-semibold small shadow-none border-0 transition-all ${activeTab === 'cupons' ? 'btn-primary text-white shadow-sm' : 'btn-light text-secondary bg-transparent'}`}
                    onClick={() => setActiveTab('cupons')}
                  >
                    🎟️ Cupons
                  </button>
                )}
                {hasPermissao('credenciamento') && (
                  <button
                    className={`btn px-4 py-2.5 rounded-3 fw-semibold small shadow-none border-0 transition-all ${activeTab === 'credenciamento' ? 'btn-primary text-white shadow-sm' : 'btn-light text-secondary bg-transparent'}`}
                    onClick={() => setActiveTab('credenciamento')}
                  >
                    📷 Credenciamento
                  </button>
                )}
                {hasPermissao('editar') && (
                  <button
                    className={`btn px-4 py-2.5 rounded-3 fw-semibold small shadow-none border-0 transition-all ${activeTab === 'editar' ? 'btn-primary text-white shadow-sm' : 'btn-light text-secondary bg-transparent'}`}
                    onClick={() => setActiveTab('editar')}
                  >
                    ⚙️ Editar Evento
                  </button>
                )}
                {hasPermissao('inscricao_interna') && (
                  <button
                    className={`btn px-4 py-2.5 rounded-3 fw-semibold small shadow-none border-0 transition-all ${activeTab === 'inscricao_interna' ? 'btn-primary text-white shadow-sm' : 'btn-light text-secondary bg-transparent'}`}
                    onClick={() => setActiveTab('inscricao_interna')}
                  >
                    📝 Inscrição Interna
                  </button>
                )}
              </div>
              <button
                className="btn btn-outline-secondary px-3 py-2 rounded-pill fw-semibold small transition-all"
                onClick={() => setSelectedEvento(null)}
              >
                ← Voltar para Eventos
              </button>
            </div>
          )}

          {/* Gerenciamento de Lotes e Inscrições */}
          {selectedEvento && editEvento && (
            <div className="print-hide mb-5">

              {activeTab === 'acesso_negado' && (
                <div className="card border-0 shadow-sm p-4 p-md-5 rounded-4 bg-white">
                  <div className="alert alert-warning mb-0">Você não possui permissão para acessar este módulo.</div>
                </div>
              )}

              {activeTab === 'editar' && hasPermissao('editar') && (
                <div className="card border-0 shadow-sm p-4 p-md-5 rounded-4 bg-white">
                  <h3 className="fw-bold text-dark mb-1">Editar Evento</h3>
                  <form onSubmit={handleUpdateEvento} className="mt-4">
                    <div className="form-group">
                      <label className="form-label">Título</label>
                      <input className="form-control" value={editEvento.titulo} onChange={e => setEditEvento({ ...editEvento, titulo: e.target.value })} required />
                    </div>
                    <div className="form-group">
                      <label className="form-label">URL Slug</label>
                      <input className="form-control" value={editEvento.slug} onChange={e => setEditEvento({ ...editEvento, slug: e.target.value })} required />
                    </div>
                    <div className="form-group">
                      <label className="form-label">Local do Evento</label>
                      <input className="form-control" value={editEvento.local || ''} onChange={e => setEditEvento({ ...editEvento, local: e.target.value })} placeholder="Ex: Salão Principal IAC, Rua de Exemplo, 123 - Buritama, SP" />
                    </div>
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem' }}>
                      <div className="form-group">
                        <label className="form-label">Data e Hora do Evento</label>
                        <input type="datetime-local" className="form-control" value={formatLocalDatetime(editEvento.data_evento)} onChange={e => setEditEvento({ ...editEvento, data_evento: e.target.value })} required />
                      </div>
                      <div className="form-group">
                        <label className="form-label">Data Limite de Inscrição Geral</label>
                        <input type="datetime-local" className="form-control" value={formatLocalDatetime(editEvento.data_validade_evento)} onChange={e => setEditEvento({ ...editEvento, data_validade_evento: e.target.value })} />
                      </div>
                    </div>
                    <div className="form-group">
                      <label className="form-label">Imagem do Evento</label>
                      <input
                        type="file"
                        accept="image/*"
                        className="form-control"
                        onChange={e => {
                          const file = e.target.files[0];
                          if (file) {
                            const reader = new FileReader();
                            reader.onloadend = () => {
                              setEditEvento({ ...editEvento, imagem_url: reader.result });
                            };
                            reader.readAsDataURL(file);
                          }
                        }}
                      />
                      {editEvento.imagem_url && (
                        <div className="mt-2" style={{ position: 'relative', display: 'inline-block' }}>
                          <img
                            src={editEvento.imagem_url}
                            alt="Prévia"
                            style={{ maxHeight: '120px', borderRadius: '8px', border: '1px solid var(--border)' }}
                          />
                          <button
                            type="button"
                            className="btn btn-danger btn-sm"
                            style={{ position: 'absolute', top: '5px', right: '5px', borderRadius: '50%', padding: '0.25rem 0.5rem', fontSize: '0.75rem' }}
                            onClick={() => setEditEvento({ ...editEvento, imagem_url: '' })}
                          >
                            ✕
                          </button>
                        </div>
                      )}
                    </div>
                    <div className="form-check form-switch mb-3">
                      <input className="form-check-input" type="checkbox" role="switch" id="switchEditDestaque" checked={editEvento.destaque === 1} onChange={e => setEditEvento({ ...editEvento, destaque: e.target.checked ? 1 : 0 })} />
                      <label className="form-check-label fw-semibold" htmlFor="switchEditDestaque" style={{ cursor: 'pointer' }}>✨ Destacar este evento no carrossel da página principal</label>
                    </div>
                    <div className="form-group">
                      <label className="form-label">Descrição</label>
                      <textarea className="form-control" rows="4" value={editEvento.descricao} onChange={e => setEditEvento({ ...editEvento, descricao: e.target.value })} required />
                    </div>

                    <div style={{ borderTop: '1px solid var(--border)', paddingTop: '1.5rem', marginTop: '1.5rem' }}>
                      <h4>Campos Personalizados</h4>
                      {editCamposPersonalizados.map((campo, index) => (
                        <div key={index} style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 150px auto', gap: '1rem', marginBottom: '1rem', alignItems: 'end' }}>
                          <div>
                            <label className="form-label text-secondary small fw-semibold">Nome do Campo</label>
                            <input className="form-control" value={campo.nome} onChange={e => { const c = [...editCamposPersonalizados]; c[index].nome = e.target.value; setEditCamposPersonalizados(c); }} required />
                          </div>
                          <div>
                            <label className="form-label text-secondary small fw-semibold">Placeholder (Dica p/ usuário)</label>
                            <input className="form-control" value={campo.placeholder || ''} onChange={e => { const c = [...editCamposPersonalizados]; c[index].placeholder = e.target.value; setEditCamposPersonalizados(c); }} placeholder="Ex: Digite seu RG" />
                          </div>
                          <div>
                            <label className="form-label text-secondary small fw-semibold">Tipo</label>
                            <select className="form-control form-select" value={campo.tipo || 'text'} onChange={e => { const c = [...editCamposPersonalizados]; c[index].tipo = e.target.value; setEditCamposPersonalizados(c); }}>
                              <option value="text">Texto Curto</option>
                              <option value="textarea">Texto Longo</option>
                              <option value="number">Número</option>
                              <option value="date">Data</option>
                            </select>
                          </div>
                          <button type="button" className="btn btn-outline-danger d-flex align-items-center justify-content-center" style={{ height: '42px', padding: '0 0.75rem' }} onClick={() => setEditCamposPersonalizados(editCamposPersonalizados.filter((_, i) => i !== index))}>
                            🗑️
                          </button>
                        </div>
                      ))}
                      <button type="button" className="btn btn-outline-secondary" style={{ borderStyle: 'dashed', width: '100%', marginBottom: '1.5rem' }} onClick={() => setEditCamposPersonalizados([...editCamposPersonalizados, { nome: '', tipo: 'text', placeholder: '' }])}>
                        + Adicionar Campo Extra
                      </button>
                    </div>

                    <button type="submit" className="btn btn-primary" style={{ width: '100%' }}>Salvar Alterações do Evento</button>
                  </form>
                </div>
              )}

              {activeTab === 'lotes' && hasPermissao('lotes') && (
                <div className="card border-0 shadow-sm p-4 p-md-5 rounded-4 bg-white">
                  <div className="d-flex justify-content-between align-items-center flex-wrap gap-3 mb-4">
                    <div>
                      <h3 className="fw-bold fs-4 text-dark mb-1">Gerenciar Lotes: {selectedEvento.titulo}</h3>
                      <p className="text-secondary mb-0">
                        Configure os valores e vagas dos lotes para liberar as inscrições.
                      </p>
                    </div>
                    <button
                      className="btn btn-primary px-4 py-2.5 rounded-3 fw-semibold shadow-sm border-0 d-flex align-items-center gap-2"
                      style={{ fontSize: '0.875rem' }}
                      onClick={() => { setEditingLote(null); setShowLoteModal(true); }}
                    >
                      ➕ Novo Lote
                    </button>
                  </div>

                  <div className="table-responsive bg-light border rounded-4 p-2 mt-2 shadow-sm" style={{ overflowX: 'auto' }}>
                    <table className="table table-hover align-middle mb-0" style={{ fontSize: '0.925rem' }}>
                      <thead className="table-light text-secondary">
                        <tr>
                          <th style={{ whiteSpace: 'nowrap' }}>Nome</th>
                          <th style={{ whiteSpace: 'nowrap' }}>Preço</th>
                          <th style={{ whiteSpace: 'nowrap' }}>Vagas Totais</th>
                          <th style={{ whiteSpace: 'nowrap' }}>Vendidas</th>
                          <th style={{ whiteSpace: 'nowrap' }}>Restantes</th>
                          <th style={{ whiteSpace: 'nowrap' }}>Início</th>
                          <th style={{ whiteSpace: 'nowrap' }}>Validade</th>
                          <th style={{ whiteSpace: 'nowrap' }}>Visibilidade</th>
                          <th style={{ whiteSpace: 'nowrap' }}>Status</th>
                          <th style={{ width: '150px', whiteSpace: 'nowrap' }}>Ações</th>
                        </tr>
                      </thead>
                      <tbody>
                        {lotes && lotes.map(lote => {
                          const esgotado = lote.quantidade_vendida >= lote.quantidade;
                          const naoIniciado = lote.data_inicio && new Date(lote.data_inicio) > new Date();
                          const expirado = lote.data_validade && new Date(lote.data_validade) < new Date();
                          return (
                            <tr key={lote.id}>
                              <td style={{ whiteSpace: 'nowrap' }}>
                                <strong>{lote.nome}</strong>
                                {Number(lote.principal) === 1 && <span className="ms-1" title="Lote principal">⭐</span>}
                                {Number(lote.permite_duplicidade) === 1 && <span className="ms-1" title="Permite inscrição duplicada">🎫</span>}
                              </td>
                              <td style={{ color: 'var(--primary)', fontWeight: 'bold', whiteSpace: 'nowrap' }}>
                                {Number(lote.preco) === 0 ? 'Grátis' : Number(lote.preco).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
                              </td>
                              <td style={{ whiteSpace: 'nowrap' }}>{lote.quantidade}</td>
                              <td style={{ whiteSpace: 'nowrap' }}>{lote.quantidade_vendida}</td>
                              <td style={{ whiteSpace: 'nowrap' }}>{lote.quantidade - lote.quantidade_vendida}</td>
                              <td style={{ whiteSpace: 'nowrap' }}>{lote.data_inicio ? new Date(lote.data_inicio).toLocaleString('pt-BR') : 'Imediato'}</td>
                              <td style={{ whiteSpace: 'nowrap' }}>{lote.data_validade ? new Date(lote.data_validade).toLocaleString('pt-BR') : 'Sem prazo'}</td>
                              <td style={{ whiteSpace: 'nowrap' }}>
                                {Number(lote.visivel_publico) === 0 ? (
                                  <span className="text-muted"><small>🔒 Privado (Admin)</small></span>
                                ) : (
                                  <span className="text-success"><small>🌐 Público</small></span>
                                )}
                              </td>
                              <td style={{ whiteSpace: 'nowrap' }}>
                                {esgotado ? (
                                  <span className="badge badge-danger">Esgotado</span>
                                ) : naoIniciado ? (
                                  <span className="badge badge-warning text-dark">Agendado</span>
                                ) : expirado ? (
                                  <span className="badge badge-danger">Expirado</span>
                                ) : (
                                  <span className="badge badge-success">Ativo</span>
                                )}
                              </td>
                              <td>
                                <div className="d-flex gap-1">
                                  <button
                                    type="button"
                                    className="btn btn-sm btn-outline-primary"
                                    style={{ fontSize: '0.75rem', padding: '0.25rem 0.5rem' }}
                                    onClick={() => { setEditingLote(lote); setShowLoteModal(true); }}
                                  >
                                    ✏️ Editar
                                  </button>
                                  <button
                                    type="button"
                                    className="btn btn-sm btn-outline-danger"
                                    style={{ fontSize: '0.75rem', padding: '0.25rem 0.5rem' }}
                                    onClick={() => handleDeleteLote(lote.id)}
                                  >
                                    🗑️ Excluir
                                  </button>
                                </div>
                              </td>
                            </tr>
                          );
                        })}
                        {(!lotes || lotes.length === 0) && (
                          <tr>
                            <td colSpan="8" style={{ textAlign: 'center' }}>Nenhum lote criado ainda.</td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}

              {activeTab === 'cupons' && hasPermissao('cupons') && (
                <div className="card border-0 shadow-sm p-4 p-md-5 rounded-4 bg-white">
                  <div className="d-flex justify-content-between align-items-center flex-wrap gap-3 mb-4">
                    <div>
                      <h3 className="fw-bold fs-4 text-dark mb-1">🎟️ Gerenciar Cupons: {selectedEvento.titulo}</h3>
                      <p className="text-secondary mb-0">
                        Crie e gerencie cupons de desconto específicos para este evento.
                      </p>
                    </div>
                    <button
                      className="btn btn-primary px-4 py-2.5 rounded-3 fw-semibold shadow-sm border-0 d-flex align-items-center gap-2"
                      style={{ fontSize: '0.875rem' }}
                      onClick={() => { setEditingCupom(null); setShowCupomModal(true); }}
                    >
                      ➕ Novo Cupom
                    </button>
                  </div>

                  <div className="table-responsive bg-light border rounded-4 p-2 mt-2 shadow-sm" style={{ overflowX: 'auto' }}>
                    <table className="table table-hover align-middle mb-0" style={{ fontSize: '0.925rem' }}>
                      <thead className="table-light text-secondary">
                        <tr>
                          <th style={{ whiteSpace: 'nowrap' }}>Código</th>
                          <th style={{ whiteSpace: 'nowrap' }}>Desconto</th>
                          <th style={{ whiteSpace: 'nowrap' }}>Usos</th>
                          <th style={{ whiteSpace: 'nowrap' }}>Validade</th>
                          <th style={{ whiteSpace: 'nowrap' }}>Status</th>
                          <th style={{ width: '150px', whiteSpace: 'nowrap' }}>Ações</th>
                        </tr>
                      </thead>
                      <tbody>
                        {cupons
                          .filter(c => Number(c.evento_id) === Number(selectedEvento.id))
                          .map(cupom => {
                            const expirado = cupom.data_validade && new Date(cupom.data_validade) < new Date();
                            const limiteAtingido = cupom.quantidade_limite !== null && cupom.quantidade_usada >= cupom.quantidade_limite;
                            const ativo = !expirado && !limiteAtingido;

                            return (
                              <tr key={cupom.id}>
                                <td style={{ whiteSpace: 'nowrap' }}><strong>{cupom.codigo}</strong></td>
                                <td style={{ whiteSpace: 'nowrap' }}>
                                  {cupom.tipo === 'porcentagem' ? `${Number(cupom.valor)}%` : Number(cupom.valor).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
                                </td>
                                <td style={{ whiteSpace: 'nowrap' }}>
                                  {cupom.quantidade_usada} / {cupom.quantidade_limite !== null ? cupom.quantidade_limite : '∞'}
                                </td>
                                <td style={{ whiteSpace: 'nowrap' }}>
                                  {cupom.data_validade ? new Date(cupom.data_validade).toLocaleString('pt-BR') : 'Sem validade'}
                                </td>
                                <td style={{ whiteSpace: 'nowrap' }}>
                                  {ativo ? (
                                    <span className="badge badge-success">Ativo</span>
                                  ) : (
                                    <span className="badge badge-danger">{expirado ? 'Expirado' : 'Esgotado'}</span>
                                  )}
                                </td>
                                <td>
                                  <div className="d-flex gap-1">
                                    <button
                                      type="button"
                                      className="btn btn-sm btn-outline-primary"
                                      style={{ fontSize: '0.75rem', padding: '0.25rem 0.5rem' }}
                                      onClick={() => { setEditingCupom(cupom); setShowCupomModal(true); }}
                                    >
                                      ✏️ Editar
                                    </button>
                                    <button
                                      type="button"
                                      className="btn btn-sm btn-outline-danger"
                                      style={{ fontSize: '0.75rem', padding: '0.25rem 0.5rem' }}
                                      onClick={() => handleDeleteCupom(cupom.id)}
                                    >
                                      🗑️ Excluir
                                    </button>
                                  </div>
                                </td>
                              </tr>
                            );
                          })}
                        {cupons.filter(c => Number(c.evento_id) === Number(selectedEvento.id)).length === 0 && (
                          <tr>
                            <td colSpan="6" style={{ textAlign: 'center' }}>Nenhum cupom criado para este evento ainda.</td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}
            </div>
          )}

          {/* Inscrições do Evento Selecionado */}
          {selectedEvento && activeTab === 'inscricoes' && hasPermissao('inscricoes') && (() => {
            const totalInscritos = inscricoes.length;
            const totalAprovados = inscricoes.filter(i => String(i.status || '').toLowerCase() === 'approved').length;
            const totalCredenciados = inscricoes.filter(i => String(i.status || '').toLowerCase() === 'credenciado').length;
            const totalPendentes = inscricoes.filter(i => String(i.status || '').toLowerCase() === 'pending').length;
            const receitaTotal = inscricoes
              .filter(i => {
                const s = String(i.status || '').toLowerCase();
                return s === 'approved' || s === 'credenciado';
              })
              .reduce((acc, i) => acc + Number(i.valor_pago || 0), 0);

            const filteredInscricoes = inscricoes.filter(insc => {
              if (inscricaoSearch) {
                const searchLower = inscricaoSearch.toLowerCase();
                const nomeMatch = insc.nome && insc.nome.toLowerCase().includes(searchLower);
                const emailMatch = insc.email && insc.email.toLowerCase().includes(searchLower);
                const cpfMatch = insc.cpf && insc.cpf.toLowerCase().includes(searchLower);
                if (!nomeMatch && !emailMatch && !cpfMatch) return false;
              }

              if (inscricaoStatusFilter !== 'todos') {
                const statusLower = String(insc.status || '').toLowerCase();
                if (inscricaoStatusFilter === 'approved' && statusLower !== 'approved') return false;
                if (inscricaoStatusFilter === 'credenciado' && statusLower !== 'credenciado') return false;
                if (inscricaoStatusFilter === 'pending' && statusLower !== 'pending') return false;
                if (inscricaoStatusFilter === 'cancelado' && statusLower !== 'cancelled') return false;
                if (inscricaoStatusFilter === 'reembolsado' && statusLower !== 'refunded') return false;
                if (inscricaoStatusFilter === 'recusado' && !['rejected', 'cancelled', 'refunded'].includes(statusLower)) return false;
              }

              if (inscricaoLoteFilter !== 'todos') {
                if (Number(insc.lote_id) !== Number(inscricaoLoteFilter)) return false;
              }

              return true;
            });

            const totalPages = Math.max(1, Math.ceil(filteredInscricoes.length / inscricoesPerPage));
            const safePage = Math.min(inscricoesPage, totalPages);
            const paginatedInscricoes = filteredInscricoes.slice((safePage - 1) * inscricoesPerPage, safePage * inscricoesPerPage);

            return (
              <div className="card border-0 shadow-sm p-2 p-md-3 rounded-4 bg-white print-section mt-3">
                <div className="d-flex justify-content-between align-items-center mb-3 print-hide flex-wrap gap-2">
                  <h3 className="fw-bold fs-5 text-dark mb-0">Inscrições para {selectedEvento.titulo}</h3>
                  <PDFDownloadLink
                    document={<InscritosPDF evento={selectedEvento} inscricoes={filteredInscricoes} />}
                    fileName={`inscritos-${selectedEvento.slug || 'evento'}.pdf`}
                    className="btn btn-primary btn-sm px-3 rounded-pill fw-semibold shadow-sm d-inline-flex align-items-center gap-2"
                    style={{ textDecoration: 'none' }}
                  >
                    {({ blob, url, loading, error }) =>
                      loading ? '⏳ Gerando PDF...' : '📄 Baixar Relatório PDF'
                    }
                  </PDFDownloadLink>
                </div>

                {/* Dashboard Statistics Cards */}
                <div className="row g-2 mb-3 print-hide">
                  <div className="col-6 col-md-4 col-lg-2.4" style={{ flex: '1 0 18%' }}>
                    <div className="card border p-2 rounded-4 bg-light shadow-sm text-center">
                      <span className="text-secondary fw-semibold uppercase" style={{ fontSize: '0.7rem', letterSpacing: '0.5px' }}>INSCRITOS</span>
                      <h4 className="fw-bold mb-0 mt-1 text-dark">{totalInscritos}</h4>
                    </div>
                  </div>
                  <div className="col-6 col-md-4 col-lg-2.4" style={{ flex: '1 0 18%' }}>
                    <div className="card border p-2 rounded-4 bg-light shadow-sm text-center">
                      <span className="text-success fw-semibold uppercase" style={{ fontSize: '0.7rem', letterSpacing: '0.5px' }}>APROVADOS</span>
                      <h4 className="fw-bold mb-0 mt-1 text-success">{totalAprovados}</h4>
                    </div>
                  </div>
                  <div className="col-6 col-md-4 col-lg-2.4" style={{ flex: '1 0 18%' }}>
                    <div className="card border p-2 rounded-4 bg-light shadow-sm text-center">
                      <span className="text-primary fw-semibold uppercase" style={{ fontSize: '0.7rem', letterSpacing: '0.5px' }}>CREDENCIADOS</span>
                      <h4 className="fw-bold mb-0 mt-1 text-primary">{totalCredenciados}</h4>
                    </div>
                  </div>
                  <div className="col-6 col-md-4 col-lg-2.4" style={{ flex: '1 0 18%' }}>
                    <div className="card border p-2 rounded-4 bg-light shadow-sm text-center">
                      <span className="text-warning fw-semibold uppercase" style={{ fontSize: '0.7rem', letterSpacing: '0.5px' }}>PENDENTES</span>
                      <h4 className="fw-bold mb-0 mt-1 text-warning">{totalPendentes}</h4>
                    </div>
                  </div>
                  <div className="col-12 col-md-4 col-lg-2.4" style={{ flex: '1 0 18%' }}>
                    <div className="card border p-2 rounded-4 bg-light shadow-sm text-center">
                      <span className="text-info fw-semibold uppercase" style={{ fontSize: '0.7rem', letterSpacing: '0.5px' }}>RECEITA</span>
                      <h4 className="fw-bold mb-0 mt-1 text-info" style={{ fontSize: '1rem', whiteSpace: 'nowrap' }}>
                        {receitaTotal.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
                      </h4>
                    </div>
                  </div>
                </div>

                {/* Filtros de Inscrições */}
                <div className="row g-3 mb-3 print-hide align-items-end">
                  <div className="col-12 col-md-5">
                    <label className="form-label text-secondary small fw-semibold">🔍 Pesquisar Participante</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Pesquisar por nome, e-mail ou CPF..."
                      value={inscricaoSearch}
                      onChange={e => setInscricaoSearch(e.target.value)}
                    />
                  </div>
                  <div className="col-12 col-md-3">
                    <label className="form-label text-secondary small fw-semibold">🏷️ Filtrar por Situação</label>
                    <select
                      className="form-control form-select"
                      value={inscricaoStatusFilter}
                      onChange={e => setInscricaoStatusFilter(e.target.value)}
                    >
                      <option value="todos">Todas as situações</option>
                      <option value="approved">Aprovados</option>
                      <option value="credenciado">Credenciados</option>
                      <option value="pending">Pendentes</option>
                      <option value="cancelado">Cancelados</option>
                      <option value="reembolsado">Reembolsados</option>
                      <option value="recusado">Recusados</option>
                    </select>
                  </div>
                  <div className="col-12 col-md-3">
                    <label className="form-label text-secondary small fw-semibold">🎟️ Filtrar por Lote</label>
                    <select
                      className="form-control form-select"
                      value={inscricaoLoteFilter}
                      onChange={e => setInscricaoLoteFilter(e.target.value)}
                    >
                      <option value="todos">Todos os Lotes</option>
                      {lotes.map(l => (
                        <option key={l.id} value={l.id}>{l.nome}</option>
                      ))}
                    </select>
                  </div>
                  <div className="col-12 col-md-1 text-md-end">
                    <button
                      className="btn btn-outline-secondary w-100"
                      onClick={() => {
                        setInscricaoSearch('');
                        setInscricaoStatusFilter('todos');
                        setInscricaoLoteFilter('todos');
                      }}
                      title="Limpar Filtros"
                    >
                      Limpar
                    </button>
                  </div>
                </div>

                <div className="row g-2 mb-3 print-hide align-items-center">
                  <div className="col-12 col-md-6">
                    <span className="text-secondary small fw-semibold">
                      Exibindo {(safePage - 1) * inscricoesPerPage + 1}-{Math.min(safePage * inscricoesPerPage, filteredInscricoes.length)} de {filteredInscricoes.length}
                    </span>
                  </div>
                  <div className="col-12 col-md-6 text-md-end">
                    <ReactPaginate
                      previousLabel={'←'}
                      nextLabel={'→'}
                      breakLabel={'…'}
                      pageCount={totalPages}
                      forcePage={safePage - 1}
                      onPageChange={({ selected }) => setInscricoesPage(selected + 1)}
                      containerClassName="pagination pagination-sm justify-content-md-end mb-0"
                      pageClassName="page-item"
                      pageLinkClassName="page-link rounded-pill mx-1"
                      activeClassName="active"
                      previousClassName="page-item"
                      previousLinkClassName="page-link rounded-pill"
                      nextClassName="page-item"
                      nextLinkClassName="page-link rounded-pill"
                      breakClassName="page-item"
                      breakLinkClassName="page-link rounded-pill"
                      disabledClassName="disabled"
                    />
                  </div>
                </div>

                <div className="table-responsive">
                  <table className="table align-middle mb-0">
                    <thead>
                      <tr className="text-secondary small">
                        <th scope="col" style={{ whiteSpace: 'nowrap' }}>Participante</th>
                        <th scope="col" style={{ whiteSpace: 'nowrap' }}>CPF</th>
                        <th scope="col" style={{ whiteSpace: 'nowrap' }}>Lote</th>
                        <th scope="col" style={{ whiteSpace: 'nowrap' }}>Data</th>
                        <th scope="col" style={{ whiteSpace: 'nowrap' }}>Status</th>
                        <th scope="col" style={{ whiteSpace: 'nowrap' }}>Valor</th>
                        <th scope="col" className="print-hide" style={{ whiteSpace: 'nowrap' }}>Ações</th>
                      </tr>
                    </thead>
                    <tbody>
                      {paginatedInscricoes.map(insc => {
                        let respostas = {};
                        try { if (insc.respostas) respostas = typeof insc.respostas === 'string' ? JSON.parse(insc.respostas) : insc.respostas; } catch (e) { }

                        const statusLower = String(insc.status || '').toLowerCase();
                        let statusLabel = statusLower;
                        let badgeClass = 'warning';

                        if (statusLower === 'approved') {
                          statusLabel = 'Aprovado';
                          badgeClass = 'success';
                        } else if (statusLower === 'credenciado') {
                          statusLabel = 'Credenciado';
                          badgeClass = 'success';
                        } else if (statusLower === 'pending') {
                          statusLabel = 'Pendente';
                          badgeClass = 'warning';
                        } else if (statusLower === 'rejected') {
                          statusLabel = 'Recusado';
                          badgeClass = 'danger';
                        } else if (statusLower === 'refunded') {
                          statusLabel = 'Reembolsado';
                          badgeClass = 'danger';
                        } else if (statusLower === 'cancelled') {
                          statusLabel = 'Cancelado';
                          badgeClass = 'danger';
                        }

                        return (
                          <tr key={insc.id}>
                            <td>
                              <div className="fw-semibold text-dark">{insc.nome}</div>
                              <div className="text-secondary small" style={{ wordBreak: 'break-word' }}>{insc.email}</div>
                              {Object.keys(respostas).length > 0 && (
                                <div className="text-secondary small mt-1">
                                  {Object.entries(respostas).slice(0, 2).map(([key, val]) => (
                                    <span key={key} className="d-block">{key}: {String(val)}</span>
                                  ))}
                                </div>
                              )}
                            </td>
                            <td className="font-monospace text-dark">{insc.cpf || '—'}</td>
                            <td className="text-secondary">{insc.lote_nome}</td>
                            <td className="text-secondary">{new Date(insc.data_inscricao).toLocaleDateString('pt-BR')}</td>
                            <td>
                              <span className={`badge badge-${badgeClass}`} style={{ textTransform: 'uppercase', fontSize: '0.72rem', fontWeight: '700', padding: '0.35em 0.65em' }}>
                                {statusLabel}
                              </span>
                            </td>
                            <td className="fw-semibold text-primary">{Number(insc.valor_pago || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</td>
                            <td className="print-hide">
                              <div className="position-relative">
                                <button
                                  className="btn btn-sm btn-light border rounded-circle p-2"
                                  onClick={() => setActionMenuOpenId(actionMenuOpenId === insc.id ? null : insc.id)}
                                  title="Mais opções"
                                >
                                  ⋯
                                </button>
                                {actionMenuOpenId === insc.id && (
                                  <div className="dropdown-menu show position-absolute end-0 mt-2 rounded-3 shadow border bg-white" style={{ minWidth: '180px', zIndex: 10 }}>
                                    {statusLower === 'pending' && (
                                      <button className="dropdown-item text-start" onClick={() => { setActionMenuOpenId(null); handleConfirmInscricao(insc.id); }}>
                                        Confirmar
                                      </button>
                                    )}
                                    {(statusLower === 'approved' || statusLower === 'credenciado') && (
                                      <button className="dropdown-item text-start" onClick={() => { setActionMenuOpenId(null); handleResendEmail(insc.id); }}>
                                        Reenviar e-mail
                                      </button>
                                    )}
                                    <button className="dropdown-item text-start" onClick={() => { setActionMenuOpenId(null); openEditInscricao(insc); }}>
                                      Alterar
                                    </button>
                                    <button className="dropdown-item text-start text-danger" onClick={() => { setActionMenuOpenId(null); handleCancelInscricao(insc); }}>
                                      Cancelar
                                    </button>
                                  </div>
                                )}
                              </div>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                  {paginatedInscricoes.length === 0 && (
                    <div className="text-center py-4 text-secondary">Nenhuma inscrição encontrada para os filtros aplicados.</div>
                  )}
                </div>

                <div className="d-flex justify-content-between align-items-center mt-2 print-hide flex-wrap gap-2">
                  <span className="text-secondary small fw-semibold">Página {safePage} de {totalPages}</span>
                </div>
              </div>
            );
          })()}

          {/* Credenciamento via QR Code (Câmera) ou CPF */}
          {selectedEvento && activeTab === 'credenciamento' && hasPermissao('credenciamento') && (
            <div className="card border-0 shadow-sm p-3 p-sm-4 p-md-5 rounded-4 bg-white print-section" style={{ width: '100%', overflowX: 'hidden' }}>
              <h3 className="text-center fw-extrabold text-dark mb-2" style={{ fontWeight: 800 }}>
                🎫 Credenciamento do Participante
              </h3>
              <p className="text-secondary text-center mx-auto mb-5" style={{ maxWidth: '600px', fontSize: '0.95rem' }}>
                Realize o credenciamento de presença lendo o QR Code com a câmera ou pesquisando pelo CPF cadastrado.
              </p>

              {/* Mensagem de Erro na busca/validação */}
              {scanError && (
                <div className="alert alert-danger alert-dismissible fade show rounded-3 p-3 mb-4 mx-auto" style={{ maxWidth: '600px' }} role="alert">
                  <strong className="d-block mb-1">⚠️ Erro na Operação:</strong>
                  <span style={{ fontSize: '0.9rem' }}>{scanError}</span>
                  <button type="button" className="btn-close shadow-none" onClick={() => setScanError(null)} aria-label="Close"></button>
                </div>
              )}

              {/* Caso 1: Sucesso ao confirmar check-in */}
              {checkinSuccess && (
                <div className="text-center py-5 px-4 bg-white rounded-4 border mx-auto shadow-sm animate__animated animate__zoomIn" style={{ maxWidth: '500px' }}>
                  <div className="bg-success text-white rounded-circle d-flex align-items-center justify-content-center mx-auto mb-4" style={{ width: '70px', height: '70px', fontSize: '2rem', display: 'flex', alignSelf: 'center' }}>
                    ✓
                  </div>
                  <h3 className="fw-bold text-success mb-2">Credenciado com Sucesso!</h3>
                  <p className="text-secondary mb-4" style={{ fontSize: '0.95rem' }}>{checkinSuccess}</p>
                  <button className="btn btn-primary px-5 py-2.5 rounded-pill fw-semibold" onClick={() => setCheckinSuccess(null)}>
                    Realizar Próximo Credenciamento
                  </button>
                </div>
              )}

              {/* Modal de Validação / Credenciamento */}
              {(pendingTicket || ticketOptions.length > 1) && (
                <div
                  className="modal fade show"
                  tabIndex="-1"
                  style={{
                    display: 'block',
                    backgroundColor: 'rgba(15, 23, 42, 0.65)',
                    backdropFilter: 'blur(8px)',
                    zIndex: 1050
                  }}
                >
                  <div className="modal-dialog modal-dialog-centered" style={{ maxWidth: '480px', margin: '1.25rem auto', padding: '0 1rem' }}>
                    <div className="modal-content border-0 shadow bg-white rounded-4 overflow-hidden animate__animated animate__fadeInUp" style={{ maxHeight: '90vh', display: 'flex', flexDirection: 'column' }}>

                      {/* Header */}
                      <div className="modal-header border-0 bg-light p-4 pb-3 d-flex align-items-center justify-content-between">
                        <div>
                          <span className="badge bg-primary text-white rounded-pill px-3 py-1.5 mb-1" style={{ fontSize: '0.75rem', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                            {!pendingTicket
                              ? 'Selecione o Lote'
                              : ['cancelled', 'refunded', 'rejected'].includes(pendingTicket.status)
                                ? 'Inscrição Cancelada'
                                : pendingTicket.status === 'credenciado' ? 'Já Credenciado' : 'Validação de Entrada'}
                          </span>
                          <h5 className="modal-title fw-bold text-dark mt-1">🎫 {!pendingTicket ? 'Mais de uma inscrição encontrada' : 'Detalhes da Inscrição'}</h5>
                        </div>
                        <button
                          type="button"
                          className="btn-close shadow-none"
                          onClick={handleCancelCheckin}
                          aria-label="Close"
                          disabled={loadingCheckin}
                        ></button>
                      </div>

                      {/* Body */}
                      <div className="modal-body p-4 overflow-auto" style={{ flex: '1 1 auto' }}>
                        {!pendingTicket ? (
                          <div>
                            <p className="text-secondary mb-3" style={{ fontSize: '0.9rem' }}>
                              Este CPF possui mais de uma inscrição para este evento. Selecione qual lote está credenciando agora:
                            </p>
                            <div className="d-flex flex-column gap-2">
                              {ticketOptions.map(opcao => (
                                <label
                                  key={opcao.id}
                                  className="d-flex align-items-center gap-3 p-3 border rounded-3"
                                  style={{ cursor: 'pointer' }}
                                >
                                  <input
                                    type="radio"
                                    name="ticketOption"
                                    className="form-check-input m-0"
                                    onChange={() => setPendingTicket(opcao)}
                                  />
                                  <div className="flex-grow-1">
                                    <strong className="d-block">{opcao.lote_nome}</strong>
                                    <span className="text-secondary" style={{ fontSize: '0.8rem' }}>
                                      #INSC_{opcao.id} · {opcao.status === 'approved' ? 'Pago / Aprovado'
                                        : opcao.status === 'credenciado' ? 'Já Credenciado'
                                        : opcao.status === 'cancelled' ? 'Cancelada'
                                        : opcao.status === 'refunded' ? 'Cancelada / Reembolsada'
                                        : opcao.status === 'rejected' ? 'Rejeitada'
                                        : opcao.status}
                                    </span>
                                  </div>
                                </label>
                              ))}
                            </div>
                          </div>
                        ) : (
                          <>
                        {ticketOptions.length > 1 && (
                          <button
                            type="button"
                            className="btn btn-link btn-sm text-secondary px-0 mb-2"
                            onClick={() => setPendingTicket(null)}
                          >
                            ← Trocar inscrição selecionada
                          </button>
                        )}
                        <div className="text-center mb-4 pb-3 border-bottom">
                          <h4 className="fw-extrabold text-dark mb-0" style={{ fontSize: '1.5rem', fontWeight: 800 }}>
                            {pendingTicket.nome}
                          </h4>
                        </div>

                        <div className="row g-3" style={{ fontSize: '0.925rem' }}>
                          <div className="col-12 col-sm-6">
                            <span className="text-secondary d-block" style={{ fontSize: '0.775rem', fontWeight: 600 }}>CPF do Participante</span>
                            <strong>{pendingTicket.cpf || 'Não cadastrado'}</strong>
                          </div>
                          <div className="col-12 col-sm-6">
                            <span className="text-secondary d-block" style={{ fontSize: '0.775rem', fontWeight: 600 }}>Tipo de Ingresso</span>
                            <strong className="text-primary">{pendingTicket.lote_nome}</strong>
                          </div>
                          <div className="col-12">
                            <span className="text-secondary d-block" style={{ fontSize: '0.775rem', fontWeight: 600 }}>E-mail</span>
                            <strong style={{ wordBreak: 'break-all' }}>{pendingTicket.email}</strong>
                          </div>
                          <div className="col-12 col-sm-6">
                            <span className="text-secondary d-block" style={{ fontSize: '0.775rem', fontWeight: 600 }}>Telefone</span>
                            <strong>{pendingTicket.telefone}</strong>
                          </div>
                          <div className="col-12 col-sm-6">
                            <span className="text-secondary d-block" style={{ fontSize: '0.775rem', fontWeight: 600 }}>Status Financeiro</span>
                            <span className={`badge bg-${pendingTicket.status === 'approved' ? 'success' : pendingTicket.status === 'credenciado' ? 'info' : ['cancelled', 'refunded', 'rejected'].includes(pendingTicket.status) ? 'danger' : 'warning'} text-white mt-1 px-2.5 py-1.5`} style={{ fontSize: '0.75rem', fontWeight: 600 }}>
                              {pendingTicket.status === 'approved' ? 'Pago / Aprovado'
                                : pendingTicket.status === 'credenciado' ? 'Já Credenciado'
                                : pendingTicket.status === 'cancelled' ? 'Cancelada'
                                : pendingTicket.status === 'refunded' ? 'Cancelada / Reembolsada'
                                : pendingTicket.status === 'rejected' ? 'Rejeitada'
                                : pendingTicket.status}
                            </span>
                          </div>
                        </div>

                        {/* Alerts Section */}
                        {['cancelled', 'refunded', 'rejected'].includes(pendingTicket.status) && (
                          <div className="alert alert-danger rounded-3 p-3 mt-4 mb-0 border-0" style={{ fontSize: '0.875rem' }}>
                            <div className="d-flex gap-2">
                              <span style={{ fontSize: '1.2rem' }}>🚫</span>
                              <div>
                                <strong className="text-danger">INSCRIÇÃO CANCELADA!</strong>
                                <p className="mb-0 mt-1 text-danger-emphasis">
                                  {pendingTicket.status === 'refunded'
                                    ? 'Esta inscrição foi cancelada e o valor foi estornado. A entrada não pode ser liberada.'
                                    : 'Esta inscrição foi cancelada. A entrada não pode ser liberada.'}
                                </p>
                              </div>
                            </div>
                          </div>
                        )}

                        {pendingTicket.status === 'credenciado' && (
                          <div className="alert alert-danger rounded-3 p-3 mt-4 mb-0 border-0" style={{ fontSize: '0.875rem' }}>
                            <div className="d-flex gap-2">
                              <span style={{ fontSize: '1.2rem' }}>🚫</span>
                              <div>
                                <strong className="text-danger">ENTRADA JÁ REGISTRADA!</strong>
                                <p className="mb-0 mt-1 text-danger-emphasis">Este participante já realizou o credenciamento de entrada para este evento anteriormente e não pode realizar uma nova entrada.</p>
                              </div>
                            </div>
                          </div>
                        )}

                        {pendingTicket.status === 'pending' && (
                          <div className="alert alert-warning rounded-3 p-3 mt-4 mb-0 border-0" style={{ fontSize: '0.875rem' }}>
                            <div className="d-flex gap-2">
                              <span style={{ fontSize: '1.2rem' }}>⚠️</span>
                              <div>
                                <strong className="text-warning">PAGAMENTO PENDENTE!</strong>
                                <p className="mb-0 mt-1 text-warning-emphasis">A inscrição consta como PENDENTE financeiramente. Confirme a liberação somente em caso de cortesia ou pagamento offline.</p>
                              </div>
                            </div>
                          </div>
                        )}
                        </>
                        )}
                      </div>

                      {/* Footer */}
                      <div className="modal-footer border-0 bg-light p-4 pt-3 d-flex flex-column gap-2">
                        {!pendingTicket ? (
                          <button
                            className="btn btn-outline-secondary w-100 py-2.5 rounded-pill fw-semibold"
                            onClick={handleCancelCheckin}
                          >
                            Cancelar
                          </button>
                        ) : pendingTicket.status === 'credenciado' || ['cancelled', 'refunded', 'rejected'].includes(pendingTicket.status) ? (
                          <button
                            className="btn btn-outline-secondary w-100 py-2.5 rounded-pill fw-semibold"
                            onClick={handleCancelCheckin}
                          >
                            Fechar e Voltar
                          </button>
                        ) : (
                          <div className="w-100 d-flex gap-2">
                            <button
                              className="btn btn-outline-secondary w-50 py-2.5 rounded-pill fw-semibold"
                              onClick={handleCancelCheckin}
                              disabled={loadingCheckin}
                            >
                              Cancelar
                            </button>
                            <button
                              className="btn btn-success w-50 py-2.5 rounded-pill fw-semibold d-flex align-items-center justify-content-center gap-2 text-white shadow-sm"
                              onClick={handleApproveCheckin}
                              disabled={loadingCheckin}
                            >
                              {loadingCheckin ? (
                                <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                              ) : 'Liberar Entrada'}
                            </button>
                          </div>
                        )}
                      </div>

                    </div>
                  </div>
                </div>
              )}

              {/* Caso 3: Estado de busca padrão (Scanner e CPF) */}
              {!checkinSuccess && (
                <div className="row justify-content-center">
                  <div className="col-12 col-md-8 col-lg-6">
                    <div className="card border-0 bg-white rounded-4 shadow-sm overflow-hidden">
                      {/* Nav Pills Header */}
                      <div className="d-flex p-2 bg-light border-bottom gap-2">
                        <button
                          className={`btn flex-grow-1 rounded-3 py-2 fw-semibold ${checkinMethod === 'camera' ? 'btn-white shadow-sm text-primary' : 'btn-light text-secondary border-0'}`}
                          onClick={() => setCheckinMethod('camera')}
                          style={{ backgroundColor: checkinMethod === 'camera' ? '#fff' : 'transparent' }}
                        >
                          📷 Câmera QR
                        </button>
                        <button
                          className={`btn flex-grow-1 rounded-3 py-2 fw-semibold ${checkinMethod === 'cpf' ? 'btn-white shadow-sm text-primary' : 'btn-light text-secondary border-0'}`}
                          onClick={() => setCheckinMethod('cpf')}
                          style={{ backgroundColor: checkinMethod === 'cpf' ? '#fff' : 'transparent' }}
                        >
                          💳 Digitar CPF
                        </button>
                      </div>

                      <div className="p-4 p-sm-5 text-center">
                        {checkinMethod === 'camera' ? (
                          <>
                            <h5 className="fw-bold mb-2">Leitura de QR Code</h5>
                            <p className="text-secondary small mb-4">
                              Aponte a câmera para ler o QR Code do ingresso do participante.
                            </p>

                            {scannerActive ? (
                              <div className="mx-auto" style={{ maxWidth: '350px' }}>
                                <div className="border rounded-4 overflow-hidden shadow-sm bg-black mb-4 position-relative" style={{ aspectRatio: '1/1' }}>
                                  <Scanner
                                    onScan={handleScan}
                                    onError={(error) => setScanError(error?.message || 'Erro ao iniciar câmera')}
                                  />
                                </div>
                                <button className="btn btn-outline-danger btn-sm px-4 py-2 rounded-pill fw-semibold shadow-sm" onClick={stopScanner}>
                                  Parar Câmera
                                </button>
                              </div>
                            ) : (
                              <div className="py-4">
                                <button className="btn btn-primary px-4 py-3 rounded-pill fw-bold shadow-sm" onClick={startScanner}>
                                  📷 Iniciar Câmera
                                </button>
                              </div>
                            )}
                          </>
                        ) : (
                          <>
                            <h5 className="fw-bold mb-2">Busca Manual</h5>
                            <p className="text-secondary small mb-4">
                              Insira o CPF do participante para localizar a inscrição.
                            </p>

                            <form onSubmit={handleCpfCheckin} className="mt-2 text-start">
                              <div className="mb-4">
                                <label className="form-label text-secondary small fw-semibold">CPF do Participante</label>
                                <input
                                  type="text"
                                  className="form-control form-control-lg rounded-3 shadow-none border"
                                  placeholder="000.000.000-00"
                                  required
                                  value={cpfCheckin}
                                  onChange={e => {
                                    let val = e.target.value.replace(/\D/g, '');
                                    if (val.length > 11) val = val.substring(0, 11);
                                    if (val.length > 9) {
                                      val = `${val.substring(0, 3)}.${val.substring(3, 6)}.${val.substring(6, 9)}-${val.substring(9)}`;
                                    } else if (val.length > 6) {
                                      val = `${val.substring(0, 3)}.${val.substring(3, 6)}.${val.substring(6)}`;
                                    } else if (val.length > 3) {
                                      val = `${val.substring(0, 3)}.${val.substring(3)}`;
                                    }
                                    setCpfCheckin(val);
                                  }}
                                />
                              </div>
                              <button type="submit" className="btn btn-accent w-100 py-3 rounded-pill fw-bold text-white shadow-sm" disabled={loadingCpf}>
                                {loadingCpf ? (
                                  <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                ) : 'Buscar Participante'}
                              </button>
                            </form>
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          )}

          {selectedEvento && activeTab === 'inscricao_interna' && hasPermissao('inscricao_interna') && (
            <div className="card border-0 shadow-sm p-4 p-md-5 rounded-4 bg-white animate__animated animate__fadeIn">
              <h3 className="fw-bold fs-4 text-dark mb-1">📝 Inscrição Interna (Cortesia / Admin)</h3>
              <p className="text-secondary mb-4">
                Cadastre participantes diretamente por aqui. A inscrição será gerada como <strong>Confirmada</strong> e um e-mail de confirmação com o QR Code de entrada será enviado imediatamente.
              </p>

              <form onSubmit={handleCreateInscricaoInterna} style={{ maxWidth: '750px' }}>
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '1.25rem', marginBottom: '1.5rem' }}>
                  <div className="form-group mb-0">
                    <label className="form-label text-secondary small fw-semibold">Nome Completo</label>
                    <input
                      type="text"
                      className="form-control"
                      required
                      placeholder="Ex: Alysson Paulino"
                      value={formDataInterna.nome}
                      onChange={e => setFormDataInterna({ ...formDataInterna, nome: e.target.value })}
                    />
                  </div>

                  <div className="form-group mb-0">
                    <label className="form-label text-secondary small fw-semibold">CPF</label>
                    <input
                      type="text"
                      className="form-control"
                      required
                      placeholder="Ex: 000.000.000-00"
                      value={formDataInterna.cpf}
                      onChange={e => {
                        let val = e.target.value.replace(/\D/g, '');
                        if (val.length > 11) val = val.substring(0, 11);
                        if (val.length > 9) {
                          val = `${val.substring(0, 3)}.${val.substring(3, 6)}.${val.substring(6, 9)}-${val.substring(9)}`;
                        } else if (val.length > 6) {
                          val = `${val.substring(0, 3)}.${val.substring(3, 6)}.${val.substring(6)}`;
                        } else if (val.length > 3) {
                          val = `${val.substring(0, 3)}.${val.substring(3)}`;
                        }
                        setFormDataInterna({ ...formDataInterna, cpf: val });
                      }}
                    />
                  </div>

                  <div className="form-group mb-0">
                    <label className="form-label text-secondary small fw-semibold">WhatsApp / Telefone</label>
                    <input
                      type="text"
                      className="form-control"
                      required
                      placeholder="Ex: (18) 99999-9999"
                      value={formDataInterna.telefone}
                      onChange={e => setFormDataInterna({ ...formDataInterna, telefone: e.target.value })}
                    />
                  </div>

                  <div className="form-group mb-0">
                    <label className="form-label text-secondary small fw-semibold">Endereço de E-mail</label>
                    <input
                      type="email"
                      className="form-control"
                      required
                      placeholder="Ex: participante@email.com"
                      value={formDataInterna.email}
                      onChange={e => setFormDataInterna({ ...formDataInterna, email: e.target.value })}
                    />
                  </div>

                  <div className="form-group mb-0" style={{ gridColumn: '1 / -1' }}>
                    <label className="form-label text-secondary small fw-semibold">Selecionar Lote</label>
                    <select
                      className="form-control form-select"
                      required
                      value={formDataInterna.lote_id}
                      onChange={e => setFormDataInterna({ ...formDataInterna, lote_id: e.target.value })}
                    >
                      <option value="">Selecione...</option>
                      {lotes.map(lote => (
                        <option key={lote.id} value={lote.id}>
                          {lote.nome} ({Number(lote.preco) === 0 ? 'Grátis' : Number(lote.preco).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}) {Number(lote.visivel_publico) === 0 ? '🔒 Privado (Admin)' : '🌐 Público'}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>

                {/* Campos personalizados extras do evento */}
                {editCamposPersonalizados && editCamposPersonalizados.length > 0 && (
                  <div className="border-top pt-3 mt-4 mb-4">
                    <h5 className="fw-bold mb-3 fs-6">Campos Adicionais do Evento</h5>
                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '1.25rem' }}>
                      {editCamposPersonalizados.map((campo, index) => (
                        <div className="form-group mb-0" key={index} style={{ gridColumn: campo.tipo === 'textarea' ? '1 / -1' : 'auto' }}>
                          <label className="form-label text-secondary small fw-semibold">{campo.nome}</label>
                          {campo.tipo === 'textarea' ? (
                            <textarea
                              className="form-control"
                              rows="3"
                              placeholder={campo.placeholder || ''}
                              value={respostasInterna[campo.nome] || ''}
                              onChange={e => setRespostasInterna({ ...respostasInterna, [campo.nome]: e.target.value })}
                            />
                          ) : (
                            <input
                              type={campo.tipo || 'text'}
                              className="form-control"
                              placeholder={campo.placeholder || ''}
                              value={respostasInterna[campo.nome] || ''}
                              onChange={e => setRespostasInterna({ ...respostasInterna, [campo.nome]: e.target.value })}
                            />
                          )}
                        </div>
                      ))}
                    </div>
                  </div>
                )}

                <button
                  type="submit"
                  className="btn btn-primary px-5 py-2.5 mt-2 fw-semibold text-white shadow-sm"
                  disabled={submittingInterna}
                >
                  {submittingInterna ? 'Realizando inscrição...' : 'Confirmar e Enviar Ingresso por E-mail'}
                </button>
              </form>
            </div>
          )}

        </div>  {/* fim col-lg-10 */}
      </div>  {/* fim row */}

      {editingInscricao && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          backgroundColor: 'rgba(15, 23, 42, 0.45)',
          backdropFilter: 'blur(8px)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 9999,
          padding: '1rem'
        }}>
          <div className="card border-0 shadow-lg rounded-4 p-4 w-100" style={{ maxWidth: '560px', background: '#fff', maxHeight: '90vh', overflowY: 'auto' }}>
            <h4 className="fw-bold text-dark mb-2">✏️ Alterar inscrição</h4>
            <p className="text-secondary mb-4" style={{ fontSize: '0.925rem', lineHeight: '1.6' }}>Edite os dados principais do participante e os campos extras do evento.</p>
            <div className="row g-3">
              <div className="col-12">
                <label className="form-label text-secondary small fw-semibold">Nome</label>
                <input className="form-control" value={editInscricaoData.nome} onChange={(e) => setEditInscricaoData({ ...editInscricaoData, nome: e.target.value })} />
              </div>
              <div className="col-12 col-md-6">
                <label className="form-label text-secondary small fw-semibold">E-mail</label>
                <input type="email" className="form-control" value={editInscricaoData.email} onChange={(e) => setEditInscricaoData({ ...editInscricaoData, email: e.target.value })} />
              </div>
              <div className="col-12 col-md-6">
                <label className="form-label text-secondary small fw-semibold">Telefone</label>
                <input className="form-control" value={editInscricaoData.telefone} onChange={(e) => setEditInscricaoData({ ...editInscricaoData, telefone: e.target.value })} />
              </div>
              <div className="col-12">
                <label className="form-label text-secondary small fw-semibold">CPF</label>
                <input className="form-control" value={editInscricaoData.cpf} onChange={(e) => setEditInscricaoData({ ...editInscricaoData, cpf: e.target.value })} />
              </div>
            </div>

            {selectedEvento?.campos_personalizados && (() => {
              let camposExtras = [];
              try {
                camposExtras = typeof selectedEvento.campos_personalizados === 'string'
                  ? JSON.parse(selectedEvento.campos_personalizados)
                  : (selectedEvento.campos_personalizados || []);
              } catch (e) {
                camposExtras = [];
              }

              return camposExtras.length > 0 ? (
                <div className="border-top mt-4 pt-3">
                  <h6 className="fw-bold text-dark mb-3">Campos adicionais</h6>
                  <div className="row g-3">
                    {camposExtras.map((campo, index) => (
                      <div className="col-12" key={`${campo.nome || 'campo'}-${index}`}>
                        <label className="form-label text-secondary small fw-semibold">{campo.nome}</label>
                        {campo.tipo === 'textarea' ? (
                          <textarea
                            className="form-control"
                            rows="3"
                            placeholder={campo.placeholder || ''}
                            value={editInscricaoData.respostas?.[campo.nome] || ''}
                            onChange={(e) => setEditInscricaoData({
                              ...editInscricaoData,
                              respostas: { ...editInscricaoData.respostas, [campo.nome]: e.target.value }
                            })}
                          />
                        ) : (
                          <input
                            type={campo.tipo || 'text'}
                            className="form-control"
                            placeholder={campo.placeholder || ''}
                            value={editInscricaoData.respostas?.[campo.nome] || ''}
                            onChange={(e) => setEditInscricaoData({
                              ...editInscricaoData,
                              respostas: { ...editInscricaoData.respostas, [campo.nome]: e.target.value }
                            })}
                          />
                        )}
                      </div>
                    ))}
                  </div>
                </div>
              ) : null;
            })()}

            <div className="d-flex justify-content-end gap-2 mt-4">
              <button type="button" className="btn btn-light px-4 py-2 rounded-3 fw-semibold text-secondary border" onClick={() => setEditingInscricao(null)}>
                Cancelar
              </button>
              <button type="button" className="btn btn-primary px-4 py-2 rounded-3 fw-semibold text-white shadow-sm" onClick={handleSaveInscricaoEdit}>
                Salvar alterações
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal de Confirmação Customizado (Substitui window.confirm e funciona 100% no mobile) */}
      {confirmModal.show && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          backgroundColor: 'rgba(15, 23, 42, 0.45)',
          backdropFilter: 'blur(8px)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 9999,
          padding: '1rem',
          transition: 'all 0.3s ease-in-out'
        }}>
          <div className="card border-0 shadow-lg rounded-4 p-4 w-100" style={{ maxWidth: '440px', background: '#fff' }}>
            <h4 className="fw-bold text-dark mb-2">{confirmModal.title}</h4>
            <p className="text-secondary mb-4" style={{ fontSize: '0.925rem', lineHeight: '1.6' }}>{confirmModal.message}</p>
            <div className="d-flex justify-content-end gap-2">
              <button
                type="button"
                className="btn btn-light px-4 py-2 rounded-3 fw-semibold text-secondary border"
                style={{ fontSize: '0.9rem' }}
                onClick={() => setConfirmModal(prev => ({ ...prev, show: false }))}
              >
                Cancelar
              </button>
              <button
                type="button"
                className="btn btn-primary px-4 py-2 rounded-3 fw-semibold text-white shadow-sm"
                style={{ fontSize: '0.9rem' }}
                onClick={confirmModal.onConfirm}
              >
                Confirmar
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal de Lote */}
      {showLoteModal && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(15, 23, 42, 0.6)',
          backdropFilter: 'blur(4px)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 1050,
          padding: '1rem'
        }} className="animate__animated animate__fadeIn">
          <div className="card border-0 shadow-lg p-4 rounded-4 bg-white" style={{ width: '100%', maxWidth: '500px', maxHeight: '90vh', overflowY: 'auto', transform: 'scale(1)', transition: 'transform 0.3s ease' }}>
            <div className="d-flex justify-content-between align-items-center mb-4">
              <h4 className="fw-bold mb-0 text-dark" style={{ fontSize: '1.25rem' }}>
                {editingLote ? '✏️ Editar Lote' : '🎟️ Novo Lote'}
              </h4>
              <button
                type="button"
                className="btn-close"
                aria-label="Close"
                onClick={() => { setShowLoteModal(false); setEditingLote(null); }}
                style={{ border: 'none', background: 'transparent', fontSize: '1.5rem', cursor: 'pointer', color: 'var(--text-secondary)' }}
              >
                &times;
              </button>
            </div>

            <form onSubmit={handleSaveLote}>
              <div className="form-group mb-3">
                <label className="form-label text-secondary small fw-semibold">Nome do Lote</label>
                <input
                  className="form-control"
                  placeholder="Ex: 1º Lote"
                  value={editingLote ? editingLote.nome : novoLote.nome}
                  onChange={e => editingLote
                    ? setEditingLote({ ...editingLote, nome: e.target.value })
                    : setNovoLote({ ...novoLote, nome: e.target.value })}
                  required
                />
              </div>
              <div className="form-group mb-3">
                <label className="form-label text-secondary small fw-semibold">Preço (R$)</label>
                <input
                  type="number"
                  step="0.01"
                  className="form-control"
                  placeholder="Ex: 50.00"
                  value={editingLote ? editingLote.preco : novoLote.preco}
                  onChange={e => editingLote
                    ? setEditingLote({ ...editingLote, preco: e.target.value })
                    : setNovoLote({ ...novoLote, preco: e.target.value })}
                  required
                />
              </div>
              <div className="form-group mb-3">
                <label className="form-label text-secondary small fw-semibold">Quantidade de Vagas</label>
                <input
                  type="number"
                  className="form-control"
                  placeholder="Ex: 100"
                  value={editingLote ? editingLote.quantidade : novoLote.quantidade}
                  onChange={e => editingLote
                    ? setEditingLote({ ...editingLote, quantidade: e.target.value })
                    : setNovoLote({ ...novoLote, quantidade: e.target.value })}
                  required
                />
              </div>
              <div className="form-group mb-3">
                <label className="form-label text-secondary small fw-semibold">Data de Início (Opcional)</label>
                <input
                  type="datetime-local"
                  className="form-control"
                  value={
                    editingLote
                      ? formatLocalDatetime(editingLote.data_inicio)
                      : novoLote.data_inicio
                  }
                  onChange={e => editingLote
                    ? setEditingLote({ ...editingLote, data_inicio: e.target.value })
                    : setNovoLote({ ...novoLote, data_inicio: e.target.value })}
                />
              </div>
              <div className="form-group mb-3">
                <label className="form-label text-secondary small fw-semibold">Data de Validade (Opcional)</label>
                <input
                  type="datetime-local"
                  className="form-control"
                  value={
                    editingLote
                      ? formatLocalDatetime(editingLote.data_validade)
                      : novoLote.data_validade
                  }
                  onChange={e => editingLote
                    ? setEditingLote({ ...editingLote, data_validade: e.target.value })
                    : setNovoLote({ ...novoLote, data_validade: e.target.value })}
                />
              </div>
              <div className="form-group mb-4">
                <label className="form-label text-secondary small fw-semibold">Visibilidade do Lote</label>
                <select
                  className="form-select form-control"
                  value={editingLote ? (editingLote.visivel_publico !== undefined ? Number(editingLote.visivel_publico) : 1) : Number(novoLote.visivel_publico)}
                  onChange={e => {
                    const val = Number(e.target.value);
                    if (editingLote) {
                      setEditingLote({ ...editingLote, visivel_publico: val });
                    } else {
                      setNovoLote({ ...novoLote, visivel_publico: val });
                    }
                  }}
                >
                  <option value={1}>🌐 Público (Visível para todos)</option>
                  <option value={0}>🔒 Privado (Apenas Admin/Inscrição Interna)</option>
                </select>
              </div>

              <div className="form-check form-switch mb-3">
                <input
                  className="form-check-input"
                  type="checkbox"
                  role="switch"
                  id="switchLotePrincipal"
                  checked={Number(editingLote ? editingLote.principal : novoLote.principal) === 1}
                  onChange={e => {
                    const val = e.target.checked ? 1 : 0;
                    if (editingLote) {
                      setEditingLote({ ...editingLote, principal: val });
                    } else {
                      setNovoLote({ ...novoLote, principal: val });
                    }
                  }}
                />
                <label className="form-check-label fw-semibold" htmlFor="switchLotePrincipal" style={{ cursor: 'pointer' }}>
                  ⭐ Lote principal (preço exibido na home enquanto este lote estiver vigente)
                </label>
              </div>

              <div className="form-check form-switch mb-4">
                <input
                  className="form-check-input"
                  type="checkbox"
                  role="switch"
                  id="switchLotePermiteDuplicidade"
                  checked={Number(editingLote ? editingLote.permite_duplicidade : novoLote.permite_duplicidade) === 1}
                  onChange={e => {
                    const val = e.target.checked ? 1 : 0;
                    if (editingLote) {
                      setEditingLote({ ...editingLote, permite_duplicidade: val });
                    } else {
                      setNovoLote({ ...novoLote, permite_duplicidade: val });
                    }
                  }}
                />
                <label className="form-check-label fw-semibold" htmlFor="switchLotePermiteDuplicidade" style={{ cursor: 'pointer' }}>
                  🎫 Permite comprar mesmo com inscrição já existente (ex: espaço VIP adicional)
                </label>
              </div>

              <div className="d-flex gap-2">
                <button
                  type="button"
                  className="btn btn-light w-100 py-2.5 rounded-3 fw-semibold text-secondary border"
                  onClick={() => { setShowLoteModal(false); setEditingLote(null); }}
                >
                  Cancelar
                </button>
                <button type="submit" className="btn btn-primary w-100 py-2.5 rounded-3 fw-semibold text-white shadow-sm">
                  {editingLote ? 'Salvar Alterações' : 'Criar Lote'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Modal de Cupom */}
      {showCupomModal && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(15, 23, 42, 0.6)',
          backdropFilter: 'blur(4px)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 1050,
          padding: '1rem'
        }} className="animate__animated animate__fadeIn">
          <div className="card border-0 shadow-lg p-4 rounded-4 bg-white" style={{ width: '100%', maxWidth: '500px', maxHeight: '90vh', overflowY: 'auto', transform: 'scale(1)', transition: 'transform 0.3s ease' }}>
            <div className="d-flex justify-content-between align-items-center mb-4">
              <h4 className="fw-bold mb-0 text-dark" style={{ fontSize: '1.25rem' }}>
                {editingCupom ? '✏️ Editar Cupom' : '🎟️ Novo Cupom'}
              </h4>
              <button
                type="button"
                className="btn-close"
                aria-label="Close"
                onClick={() => { setShowCupomModal(false); setEditingCupom(null); }}
                style={{ border: 'none', background: 'transparent', fontSize: '1.5rem', cursor: 'pointer', color: 'var(--text-secondary)' }}
              >
                &times;
              </button>
            </div>

            <form onSubmit={handleSaveCupom}>
              <div className="form-group mb-3">
                <label className="form-label text-secondary small fw-semibold">Código do Cupom</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Ex: PROMO10"
                  required
                  value={editingCupom ? editingCupom.codigo : novoCupom.codigo}
                  onChange={e => editingCupom
                    ? setEditingCupom({ ...editingCupom, codigo: e.target.value.toUpperCase() })
                    : setNovoCupom({ ...novoCupom, codigo: e.target.value.toUpperCase() })}
                />
              </div>
              <div className="form-group mb-3">
                <label className="form-label text-secondary small fw-semibold">Tipo de Desconto</label>
                <select
                  className="form-control"
                  value={editingCupom ? editingCupom.tipo : novoCupom.tipo}
                  onChange={e => editingCupom
                    ? setEditingCupom({ ...editingCupom, tipo: e.target.value })
                    : setNovoCupom({ ...novoCupom, tipo: e.target.value })}
                >
                  <option value="porcentagem">Porcentagem (%)</option>
                  <option value="valor">Valor Fixo (R$)</option>
                </select>
              </div>
              <div className="form-group mb-3">
                <label className="form-label text-secondary small fw-semibold">Valor do Desconto</label>
                <input
                  type="number"
                  step="0.01"
                  className="form-control"
                  placeholder={editingCupom ? (editingCupom.tipo === 'porcentagem' ? 'Ex: 10' : 'Ex: 15.00') : (novoCupom.tipo === 'porcentagem' ? 'Ex: 10' : 'Ex: 15.00')}
                  required
                  value={editingCupom ? editingCupom.valor : novoCupom.valor}
                  onChange={e => editingCupom
                    ? setEditingCupom({ ...editingCupom, valor: e.target.value })
                    : setNovoCupom({ ...novoCupom, valor: e.target.value })}
                />
              </div>
              <div className="form-group mb-3">
                <label className="form-label text-secondary small fw-semibold">Limite de Usos (Opcional)</label>
                <input
                  type="number"
                  className="form-control"
                  placeholder="Vazio p/ ilimitado"
                  value={editingCupom ? (editingCupom.quantidade_limite !== null ? editingCupom.quantidade_limite : '') : novoCupom.quantidade_limite}
                  onChange={e => editingCupom
                    ? setEditingCupom({ ...editingCupom, quantidade_limite: e.target.value })
                    : setNovoCupom({ ...novoCupom, quantidade_limite: e.target.value })}
                />
              </div>
              <div className="form-group mb-4">
                <label className="form-label text-secondary small fw-semibold">Data de Validade (Opcional)</label>
                <input
                  type="datetime-local"
                  className="form-control"
                  value={
                    editingCupom
                      ? formatLocalDatetime(editingCupom.data_validade)
                      : novoCupom.data_validade
                  }
                  onChange={e => editingCupom
                    ? setEditingCupom({ ...editingCupom, data_validade: e.target.value })
                    : setNovoCupom({ ...novoCupom, data_validade: e.target.value })}
                />
              </div>

              <div className="d-flex gap-2">
                <button
                  type="button"
                  className="btn btn-light w-100 py-2.5 rounded-3 fw-semibold text-secondary border"
                  onClick={() => { setShowCupomModal(false); setEditingCupom(null); }}
                >
                  Cancelar
                </button>
                <button type="submit" className="btn btn-primary w-100 py-2.5 rounded-3 fw-semibold text-white shadow-sm">
                  {editingCupom ? 'Salvar Cupom' : 'Criar Cupom'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

    </div>
  );
}
